const RMS_TRANSLATIONS = {
  es: {
    Save: "Guardar",
    "Saving...": "Guardando...",
    Cancel: "Cancelar",
    Close: "Cerrar",
    Refresh: "Actualizar",
    "Refreshing...": "Actualizando...",
    Apply: "Aplicar",
    Clear: "Limpiar",
    "Clear selection": "Borrar selecci\u00f3n",
    "Clear filters": "Borrar filtros",
    "Add row": "A\u00f1adir fila",
    "Edit row": "Editar fila",
    Delete: "Eliminar",
    "Setup Integrity": "Integridad de configuraci\u00f3n",
    "Check that the essential configuration is complete.":
      "Comprueba que la configuraci\u00f3n esencial est\u00e1 completa.",
    "Guided setup": "Configuraci\u00f3n guiada",
    "Configure Revenue Optimizer in this order":
      "Configura el Optimizador de ingresos en este orden",
    "Complete the seven essential steps from left to right. The last two steps are optional refinements for hotels that need them.":
      "Completa los siete pasos esenciales de izquierda a derecha. Los dos \u00faltimos son ajustes opcionales para los hoteles que los necesiten.",
    "Essential setup progress": "Progreso de la configuraci\u00f3n esencial",
    "Essential setup": "Configuraci\u00f3n esencial",
    "Next recommended: {step}": "Siguiente recomendado: {step}",
    "The essential setup is complete.": "La configuraci\u00f3n esencial est\u00e1 completa.",
    "Setup steps": "Pasos de configuraci\u00f3n",
    Complete: "Completado",
    Optional: "Opcional",
    "Needs attention": "Requiere atenci\u00f3n",
    Next: "Siguiente",
    "Current setup summary": "Resumen de la configuraci\u00f3n actual",
    "Step {number} of {total}": "Paso {number} de {total}",
    Setup: "Configuraci\u00f3n",
    "Complete when:": "Se considera completado cuando:",
    "Previous: {step}": "Anterior: {step}",
    "Next: {step}": "Siguiente: {step}",
    "Continue to Signals & Forecast": "Continuar a Se\u00f1ales y previsi\u00f3n",
    "Base pricing strategy": "Estrategia base de precios",
    "Define the hotel-wide objective, guardrails and planning horizon the optimizer should use first.":
      "Define el objetivo general del hotel, los l\u00edmites de seguridad y el horizonte de planificaci\u00f3n que el optimizador debe usar primero.",
    "Complete when one active whole-hotel strategy exists. Add category rules only for real exceptions.":
      "Se completa cuando existe una estrategia activa para todo el hotel. A\u00f1ade reglas por categor\u00eda solo para excepciones reales.",
    "Market scope and competitors": "Alcance de mercado y competidores",
    "Confirm which extracted hotels should influence the benchmark and how important each one is.":
      "Confirma qu\u00e9 hoteles extra\u00eddos deben influir en el benchmark y qu\u00e9 importancia tiene cada uno.",
    "Complete when the extraction scope is available and at least one relevant competitor is active.":
      "Se completa cuando el alcance de extracci\u00f3n est\u00e1 disponible y hay al menos un competidor relevante activo.",
    "Comparable room mapping": "Correspondencia de habitaciones comparables",
    "Room mapping": "Correspondencia de habitaciones",
    "Match your room categories and competitor room names to comparable standard room types.":
      "Relaciona tus categor\u00edas de habitaci\u00f3n y los nombres de habitaciones de los competidores con tipos de habitaci\u00f3n est\u00e1ndar comparables.",
    "Complete when every active hotel room category has a valid standard-room mapping.":
      "Se completa cuando todas las categor\u00edas activas del hotel tienen una correspondencia v\u00e1lida con una habitaci\u00f3n est\u00e1ndar.",
    "Season templates": "Plantillas de temporada",
    Seasons: "Temporadas",
    "Create a small reusable set of demand seasons such as quiet, steady, busy and peak.":
      "Crea un peque\u00f1o conjunto reutilizable de temporadas de demanda, como tranquila, estable, alta y pico.",
    "Complete when at least one active season template is ready for calendar dates.":
      "Se completa cuando hay al menos una plantilla de temporada activa preparada para asignarla a fechas.",
    "Season calendar": "Calendario de temporadas",
    Calendar: "Calendario",
    "Place the season templates on real date ranges and resolve overlaps with clear priorities.":
      "Sit\u00faa las plantillas de temporada en rangos de fechas reales y resuelve los solapamientos con prioridades claras.",
    "Complete when the operating calendar has at least one active season period.":
      "Se completa cuando el calendario operativo tiene al menos un periodo de temporada activo.",
    "Quality calibration": "Calibraci\u00f3n de calidad",
    Quality: "Calidad",
    "Set the public review signal and the maximum influence quality may have on recommendations.":
      "Configura la se\u00f1al de rese\u00f1as p\u00fablicas y la influencia m\u00e1xima que la calidad puede tener en las recomendaciones.",
    "Complete when the four quality calibration values have been reviewed and saved.":
      "Se completa cuando se han revisado y guardado los cuatro valores de calibraci\u00f3n de calidad.",
    "Room and weekday refinements": "Ajustes por habitaci\u00f3n y d\u00eda de la semana",
    Refinements: "Ajustes",
    "Optionally refine a season for room categories or weekdays that behave differently.":
      "Opcionalmente, ajusta una temporada para categor\u00edas de habitaci\u00f3n o d\u00edas de la semana que se comporten de forma distinta.",
    "Optional. Add profiles only when a real category or weekday exception exists.":
      "Opcional. A\u00f1ade perfiles solo cuando exista una excepci\u00f3n real por categor\u00eda o d\u00eda de la semana.",
    "Temporary market disruptions": "Disrupciones temporales del mercado",
    Disruptions: "Disrupciones",
    "Optionally layer exceptional events or shocks on top of the normal season calendar.":
      "Opcionalmente, superpone eventos excepcionales o impactos al calendario normal de temporadas.",
    "Optional. Use only for temporary situations that normal seasonality cannot explain.":
      "Opcional. \u00dasalo solo para situaciones temporales que la estacionalidad normal no pueda explicar.",
    "Whole-hotel strategy ready": "Estrategia para todo el hotel preparada",
    "Keep only one active whole-hotel strategy":
      "Mantén solo una estrategia activa para todo el hotel",
    "Add one active whole-hotel strategy": "A\u00f1ade una estrategia activa para todo el hotel",
    "Market extraction scope is not available yet":
      "El alcance de extracci\u00f3n de mercado todav\u00eda no est\u00e1 disponible",
    "Activate at least one relevant competitor": "Activa al menos un competidor relevante",
    "{count} active competitor": "{count} competidor activo",
    "{count} active competitors": "{count} competidores activos",
    "No hotel room categories found":
      "No se han encontrado categor\u00edas de habitaci\u00f3n del hotel",
    "{mapped}/{total} room categories mapped":
      "{mapped}/{total} categor\u00edas de habitaci\u00f3n relacionadas",
    "Create the first active season template": "Crea la primera plantilla de temporada activa",
    "{count} active season template": "{count} plantilla de temporada activa",
    "{count} active season templates": "{count} plantillas de temporada activas",
    "Requires an active season template from step 5":
      "Requiere una plantilla de temporada activa del paso 5",
    "Place an active season on the calendar": "Coloca una temporada activa en el calendario",
    "{count} active calendar period": "{count} periodo de calendario activo",
    "{count} active calendar periods": "{count} periodos de calendario activos",
    "Quality calibration reviewed": "Calibraci\u00f3n de calidad revisada",
    "Review and save the four quality values": "Revisa y guarda los cuatro valores de calidad",
    "{count} active refinement": "{count} ajuste activo",
    "{count} active refinements": "{count} ajustes activos",
    "Optional \u2014 no refinements configured": "Opcional: no hay ajustes configurados",
    "{count} active disruption": "{count} disrupci\u00f3n activa",
    "{count} active disruptions": "{count} disrupciones activas",
    "Optional \u2014 no temporary disruptions": "Opcional: no hay disrupciones temporales",
    "Quality Settings": "Ajustes de calidad",
    "Competitors": "Competidores",
    "Signals & Forecast": "Se\u00f1ales y previsi\u00f3n",
    "Market Benchmark": "Benchmark de mercado",
    "Recommendations Overview": "Resumen de recomendaciones",
    "Daily Recommendations": "Recomendaciones diarias",
    "Long-range Guidance": "Gu\u00eda a largo plazo",
    "Market Mapping Board": "Panel de mapeo de mercado",
    "Room category": "Categor\u00eda de habitaci\u00f3n",
    "Stay date": "Fecha de estancia",
    "Current occ": "Ocupaci\u00f3n actual",
    "Final occ": "Ocupaci\u00f3n final",
    "On books": "En cartera",
    "Cancel pct": "% cancelaci\u00f3n",
    "Cancel rooms": "Habitaciones canceladas",
    Pickup: "Pickup",
    "Net pickup": "Pickup neto",
    "Market baseline": "Base de mercado",
    "Market sources": "Fuentes de mercado",
    "Current price": "Precio actual",
    "Base price": "Precio base",
    Strategy: "Estrategia",
    "Forecast conf": "Conf. previsi\u00f3n",
    Forecast: "Forecast",
    "Daily features": "Features diarias",
    "Rows loaded": "Filas cargadas",
    "Avg current occupancy": "Ocupaci\u00f3n media actual",
    "Avg final occupancy": "Ocupaci\u00f3n media final",
    "Avg expected cancel pct": "% medio previsto de cancelaci\u00f3n",
    "Market signal rows": "Filas con se\u00f1al de mercado",
    "Stop sell rows": "Filas con stop sell",
    "All room categories": "Todas las categor\u00edas",
    "Loading RMS signals...": "Cargando se\u00f1ales RMS...",
    "No signal rows found for the selected filter.":
      "No se han encontrado filas de se\u00f1ales para el filtro seleccionado.",
    "Daily demand table by room category and stay date.":
      "Tabla diaria de demanda por categor\u00eda de habitaci\u00f3n y fecha de estancia.",
    "This table shows only objective RMS inputs: demand, pickup, cancellations, market baseline and the active strategy context for each room category and stay date.":
      "Esta tabla muestra solo inputs objetivos del RMS: demanda, pickup, cancelaciones, base de mercado y el contexto de estrategia activa para cada categor\u00eda y fecha de estancia.",
    "Could not load RMS meta.": "No se ha podido cargar la metainformaci\u00f3n RMS.",
    "Could not load RMS signals.": "No se han podido cargar las se\u00f1ales RMS.",
    missing: "sin datos",
    Status: "Estado",
    "Date range": "Rango de fechas",
    Started: "Iniciado",
    Finished: "Finalizado",
    "Value: {value}": "Valor: {value}",
    "Current on-books category occupancy": "Ocupaci\u00f3n actual en cartera por categor\u00eda",
    "Main forward demand signal": "Se\u00f1al principal de demanda futura",
    "Cancellation pressure before arrival": "Presi\u00f3n de cancelaci\u00f3n antes de la llegada",
    "Rows with comparable market prices": "Filas con precios comparables de mercado",
    "Rows blocked by no availability or stop sell":
      "Filas bloqueadas por falta de disponibilidad o stop sell",
    "returned_rows_or_total_rows rows returned":
      "Filas devueltas",
    "Recommendations": "Recomendaciones",
    "Long range": "Largo plazo",
    "Daily recommendation rows": "Filas diarias recomendadas",
    "Avg recommended daily price": "Precio medio diario recomendado",
    "Separate averages by currency; amounts are not combined.":
      "Medias separadas por moneda; los importes no se combinan.",
    "Average unavailable because currency could not be verified.":
      "Media no disponible porque no se ha podido verificar la moneda.",
    "Avg daily confidence": "Confianza media diaria",
    "Rows pending review": "Filas pendientes de revisi\u00f3n",
    "Approval & application workflow": "Workflow de aprobaci\u00f3n y aplicaci\u00f3n",
    "Approve, apply or roll back the complete certified run. Recommendation decisions remain immutable.":
      "Aprueba, aplica o revierte el run certificado completo. Las decisiones de recomendaci\u00f3n permanecen inmutables.",
    "Loading recommendation workflow...": "Cargando workflow de recomendaciones...",
    "Operational actions are disabled because the workflow could not be verified.":
      "Las acciones operativas est\u00e1n deshabilitadas porque no se ha podido verificar el workflow.",
    "The workflow contract could not be verified. Actions are disabled.":
      "No se ha podido verificar el contrato del workflow. Las acciones est\u00e1n deshabilitadas.",
    "Could not load the recommendation workflow.":
      "No se ha podido cargar el workflow de recomendaciones.",
    "Latest operation": "\u00daltima operaci\u00f3n",
    "Full-run operations only": "Solo operaciones sobre el run completo",
    "Held-by-policy rows remain certified no-ops and are never forced into an application.":
      "Las filas retenidas por pol\u00edtica siguen siendo no-ops certificadas y nunca se fuerzan en una aplicaci\u00f3n.",
    "Approve run": "Aprobar run",
    "Apply approved run": "Aplicar run aprobado",
    "Rollback application": "Revertir aplicaci\u00f3n",
    "Preparing preview...": "Preparando vista previa...",
    "You do not have permission to approve RMS runs.":
      "No tienes permiso para aprobar runs RMS.",
    "You do not have permission to apply RMS runs.":
      "No tienes permiso para aplicar runs RMS.",
    "You do not have permission to roll back RMS applications.":
      "No tienes permiso para revertir aplicaciones RMS.",
    "Recommendation decision": "Decisi\u00f3n de recomendaci\u00f3n",
    "Operational workflow": "Workflow operativo",
    "Approve recommendation run": "Aprobar run de recomendaciones",
    "Apply approved recommendation run": "Aplicar run de recomendaciones aprobado",
    "Rollback complete application": "Revertir la aplicaci\u00f3n completa",
    "Approve full run": "Aprobar run completo",
    "Apply full run": "Aplicar run completo",
    "Rollback full application": "Revertir aplicaci\u00f3n completa",
    "This preview covers the complete recommendation run. Partial selection is not permitted.":
      "Esta vista previa cubre el run completo de recomendaciones. No se permite una selecci\u00f3n parcial.",
    Recommendation: "Recomendaci\u00f3n",
    "And {count} more rows": "Y {count} filas m\u00e1s",
    "Audit note (optional)": "Nota de auditor\u00eda (opcional)",
    "Add context for the audit trail": "A\u00f1ade contexto para la traza de auditor\u00eda",
    "Preview expires at {time}": "La vista previa caduca a las {time}",
    "This operation is safely blocked": "Esta operaci\u00f3n est\u00e1 bloqueada de forma segura",
    "Unknown blocker": "Bloqueo desconocido",
    "The workflow preview could not be verified. Nothing was changed.":
      "No se ha podido verificar la vista previa del workflow. No se ha cambiado nada.",
    "Could not preview this workflow action.":
      "No se ha podido previsualizar esta acci\u00f3n del workflow.",
    "The preview expired. Generate a new preview.":
      "La vista previa ha caducado. Genera una nueva.",
    "Could not execute this workflow action.":
      "No se ha podido ejecutar esta acci\u00f3n del workflow.",
    "The complete recommendation run was approved.":
      "Se ha aprobado el run completo de recomendaciones.",
    "The complete run was applied in the PMS.":
      "El run completo se ha aplicado en el PMS.",
    "The complete application was rolled back in the PMS.":
      "La aplicaci\u00f3n completa se ha revertido en el PMS.",
    pending_approval: "pendiente de aprobaci\u00f3n",
    approved: "aprobado",
    rolled_back: "revertido",
    blocked: "bloqueado",
    queued: "en cola",
    processing: "procesando",
    approval_required: "requiere aprobaci\u00f3n",
    held_by_policy: "retenido por pol\u00edtica",
    applied_local: "aplicado localmente",
    rollback_blocked: "reversi\u00f3n bloqueada",
    "Total rows": "Filas totales",
    "Actionable rows": "Filas accionables",
    "Executable rows": "Filas ejecutables",
    "Pending rows": "Filas pendientes",
    "Approval-required rows": "Filas que requieren aprobaci\u00f3n",
    "Held-by-policy rows": "Filas retenidas por pol\u00edtica",
    "Certified no-op rows": "Filas no-op certificadas",
    "Changed rows": "Filas modificadas",
    "Applied rows": "Filas aplicadas",
    "Rollback rows": "Filas a revertir",
    "Price rows": "Filas de precio",
    "Length-of-stay rows": "Filas de estancia m\u00ednima/m\u00e1xima",
    "The workflow execution response could not be verified. Refresh its status.":
      "No se ha podido verificar la respuesta de ejecuci\u00f3n del workflow. Actualiza su estado.",
    "The pipeline is no longer current. Refresh and review the new run.":
      "El pipeline ya no es el actual. Actualiza y revisa el nuevo run.",
    "The approval is stale. Generate a new preview and approve the run again.":
      "La aprobaci\u00f3n est\u00e1 desactualizada. Genera una nueva vista previa y vuelve a aprobar el run.",
    "This action is no longer valid for the current workflow state.":
      "Esta acci\u00f3n ya no es v\u00e1lida para el estado actual del workflow.",
    "The workflow changed while you were reviewing it. Refresh before continuing.":
      "El workflow ha cambiado mientras lo revisabas. Actualiza antes de continuar.",
    "The execution plan changed. Generate a new preview before continuing.":
      "El plan de ejecuci\u00f3n ha cambiado. Genera una nueva vista previa antes de continuar.",
    "One or more live prices changed. Review a fresh preview before continuing.":
      "Uno o varios precios activos han cambiado. Revisa una nueva vista previa antes de continuar.",
    "The live rate state has changed since application. Rollback was safely blocked.":
      "El estado activo de tarifas ha cambiado desde la aplicaci\u00f3n. La reversi\u00f3n se ha bloqueado de forma segura.",
    "There are no executable changes in this recommendation run.":
      "No hay cambios ejecutables en este run de recomendaciones.",
    "Only a complete recommendation run using contract v6 can be operated.":
      "Solo se puede operar un run completo de recomendaciones con contrato v6.",
    "The recommendation lineage could not be verified. The run cannot be operated.":
      "No se ha podido verificar la trazabilidad de las recomendaciones. El run no se puede operar.",
    "At least one rate product is not safe to execute.":
      "Al menos un producto de tarifa no es seguro para ejecutar.",
    "At least one proposed change is protected by an active stop-sell.":
      "Al menos un cambio propuesto est\u00e1 protegido por un stop-sell activo.",
    "This operation key was already used with different data. Refresh before retrying.":
      "Esta clave de operaci\u00f3n ya se us\u00f3 con datos distintos. Actualiza antes de reintentar.",
    "Long-range rows": "Filas de largo plazo",
    "Avg long-range price": "Precio medio a largo plazo",
    "Market signal coverage": "Cobertura de se\u00f1al de mercado",
    "Stop-sell rows": "Filas con stop sell",
    "Daily window": "Ventana diaria",
    "Long-range window": "Ventana de largo plazo",
    "Loading daily recommendations...": "Cargando recomendaciones diarias...",
    "No daily recommendations found for the selected filter.":
      "No se han encontrado recomendaciones diarias para el filtro seleccionado.",
    "Loading long-range guidance...": "Cargando gu\u00eda a largo plazo...",
    "No long-range guidance rows found for the selected filter.":
      "No se han encontrado filas de gu\u00eda a largo plazo para el filtro seleccionado.",
    "Stop sell": "Stop sell",
    "Recommended price": "Precio recomendado",
    "Origin & AI": "Origen e IA",
    "How to read Origin & AI": "Cómo interpretar Origen e IA",
    "AI-assisted explanation": "Explicación asistida por IA",
    "AI explains the recommendation; price and stay rules remain deterministic.":
      "La IA explica la recomendación; el precio y las reglas de estancia siguen siendo deterministas.",
    "Validated AI number": "Valor numérico de IA validado",
    "The AI number passed deterministic limits and post-validation.":
      "El valor numérico de la IA ha superado los límites y la posvalidación deterministas.",
    "Deterministic engine": "Motor determinista",
    "Price and stay rules were calculated by the deterministic engine.":
      "El precio y las reglas de estancia han sido calculados por el motor determinista.",
    "Deterministic fallback": "Fallback determinista",
    "The AI result was not used and the deterministic result was kept.":
      "No se usó el resultado de la IA y se conservó el resultado determinista.",
    "Origin not verified": "Origen no verificado",
    "This historical row has no verifiable recommendation origin.":
      "Esta fila histórica no tiene un origen de recomendación verificable.",
    "AI rejected; deterministic result used.":
      "IA rechazada; se ha usado el resultado determinista.",
    "AI result not used; deterministic result used.":
      "No se ha usado el resultado de la IA; se ha usado el resultado determinista.",
    "AI validation: {status}": "Validación de IA: {status}",
    "Not requested": "No solicitada",
    Accepted: "Aceptada",
    Rejected: "Rechazada",
    Unavailable: "No disponible",
    "Batch error": "Error de lote",
    "Missing row": "Fila ausente",
    "Rejection codes: {codes}": "Códigos de rechazo: {codes}",
    "Rejection details are unavailable.":
      "Los detalles del rechazo no están disponibles.",
    "AI anomaly codes: {codes}": "Códigos de anomalía de IA: {codes}",
    "AI trace: {model} · {prompt}": "Traza de IA: {model} · {prompt}",
    "AI hashes: request {request} · response {response}":
      "Huellas de IA: solicitud {request} · respuesta {response}",
    "Source metadata could not be verified.":
      "No se han podido verificar los metadatos de origen.",
    "AI-assisted explanation never changes price or stay rules. Only Validated AI number means an AI numeric proposal passed deterministic validation.":
      "La explicación asistida por IA nunca cambia el precio ni las reglas de estancia. Solo Valor numérico de IA validado indica que una propuesta numérica de la IA superó la validación determinista.",
    "Pipeline not verified": "Pipeline no verificado",
    "Coherent pipeline": "Pipeline coherente",
    "Stale pipeline": "Pipeline desactualizado",
    "Checking pipeline...": "Verificando pipeline...",
    "Verifying that every section uses one published snapshot.":
      "Comprobando que todas las secciones usan una única captura publicada.",
    "Pipeline #{id}": "Pipeline #{id}",
    "Published {date}": "Publicado {date}",
    "Status: {status}": "Estado: {status}",
    "Stages {completed}/{expected}": "Etapas {completed}/{expected}",
    "This response cannot prove that all RMS sections come from one published snapshot.":
      "Esta respuesta no puede demostrar que todas las secciones del RMS procedan de una única captura publicada.",
    "Latest attempt #{id}: {status}": "Último intento #{id}: {status}",
    "Latest attempt error: {message}": "Error del último intento: {message}",
    "{count} more pipeline issues": "{count} incidencias más del pipeline",
    "All visible RMS sections belong to this published pipeline.":
      "Todas las secciones visibles del RMS pertenecen a este pipeline publicado.",
    "Cancellation curves": "Curvas de cancelación",
    "Demand forecast": "Previsión de demanda",
    "Long-range guidance": "Guía de largo plazo",
    "Daily signals": "Señales diarias",
    "Signal and forecast rows": "Filas de señales y previsión",
    "Recommendation run": "Ejecución de recomendaciones",
    "Recommendation rows": "Filas de recomendaciones",
    "Long-range run": "Ejecución de largo plazo",
    "Pinned snapshot": "Captura fijada",
    "Snapshot data is hidden because pipeline identity could not be verified.":
      "Los datos de la captura están ocultos porque no se ha podido verificar la identidad del pipeline.",
    "the pipeline": "el pipeline",
    "No published pipeline is available.": "No hay ningún pipeline publicado disponible.",
    "The pipeline has not been published.": "El pipeline no se ha publicado.",
    "The pipeline has not completed every required stage.":
      "El pipeline no ha completado todas las etapas obligatorias.",
    "The {stage} stage has no run linked to this pipeline.":
      "La etapa {stage} no tiene ninguna ejecución vinculada a este pipeline.",
    "The {stage} stage run falls outside this pipeline's execution window.":
      "La ejecución de la etapa {stage} queda fuera de la ventana de ejecución de este pipeline.",
    "The {stage} stage run uses a different date range from this pipeline.":
      "La ejecución de la etapa {stage} usa un rango de fechas distinto al de este pipeline.",
    "A newer pipeline is still running.": "Hay un pipeline más reciente todavía en ejecución.",
    "A newer pipeline attempt failed.": "Ha fallado un intento de pipeline más reciente.",
    "{section} contains legacy data without a pipeline ID.":
      "{section} contiene datos heredados sin ID de pipeline.",
    "The requested run does not belong to the published pipeline.":
      "La ejecución solicitada no pertenece al pipeline publicado.",
    "The requested run could not be found.": "No se ha encontrado la ejecución solicitada.",
    "The pipeline is still running.": "El pipeline todavía está en ejecución.",
    "The pipeline finished with an error.": "El pipeline finalizó con un error.",
    "The published pipeline is no longer current.":
      "El pipeline publicado ya no es el vigente.",
    "The pipeline was marked stale without further detail.":
      "El pipeline se marcó como desactualizado sin más detalles.",
    "{section} belongs to a different pipeline.":
      "{section} pertenece a un pipeline diferente.",
    "{section} contains data from a different pipeline.":
      "{section} contiene datos de un pipeline diferente.",
    "{section} is marked stale.": "{section} está marcada como desactualizada.",
    "Pipeline metadata is missing or invalid.":
      "Faltan los metadatos del pipeline o no son válidos.",
    "Pipeline reported: {reason}": "Incidencia comunicada por el pipeline: {reason}",
    "Delta vs current": "Delta vs actual",
    "Min stay": "Estancia m\u00ednima",
    "Max stay": "Estancia m\u00e1xima",
    Confidence: "Confianza",
    "Apply status": "Estado de aplicaci\u00f3n",
    Reason: "Motivo",
    "Block type": "Tipo de bloque",
    "Seasonality template": "Plantilla de estacionalidad",
    "Block #{id}": "Bloque #{id}",
    "Sources: {count}": "Fuentes: {count}",
    Yes: "S\u00ed",
    No: "No",
    pending: "pendiente",
    active: "activo",
    inactive: "inactivo",
    running: "ejecut\u00e1ndose",
    warning: "aviso",
    ok: "ok",
    error: "error",
    "Here you can review the final daily recommendations and the longer-term guidance proposed by the optimizer before taking any pricing decision.":
      "Aqu\u00ed puedes revisar las recomendaciones diarias finales y la gu\u00eda m\u00e1s a largo plazo propuesta por el optimizador antes de tomar cualquier decisi\u00f3n de pricing.",
    "Final optimizer output for near-term dates and longer-term guidance.":
      "Salida final del optimizador para fechas pr\u00f3ximas y gu\u00eda a m\u00e1s largo plazo.",
    "Could not load RMS recommendations.":
      "No se han podido cargar las recomendaciones RMS.",
    "Could not load RMS long-range guidance.":
      "No se ha podido cargar la gu\u00eda RMS a largo plazo.",
    "Latest successful recommendations run": "\u00daltima ejecuci\u00f3n correcta de recomendaciones",
    "{count} blocks generated": "{count} bloques generados",
    "Model confidence for detailed horizon pricing":
      "Confianza del modelo para el pricing del horizonte detallado",
    "Recommendations not yet reviewed or used operationally":
      "Recomendaciones todav\u00eda no revisadas ni usadas operativamente",
    "Average block guidance beyond detailed horizon":
      "Media de gu\u00eda por bloques m\u00e1s all\u00e1 del horizonte detallado",
    "Rows already protected by stop-sell":
      "Filas ya protegidas por stop sell",
    "{count} daily rows with comparable benchmark":
      "{count} filas diarias con benchmark comparable",
    "Detailed horizon from {from} to {to}.":
      "Horizonte detallado desde {from} hasta {to}.",
    "Guidance blocks from {from} to {to}.":
      "Bloques de gu\u00eda desde {from} hasta {to}.",
    "Loading competitor prices...": "Cargando precios de competidores...",
    "No competitor prices match the current filters.":
      "Ning\u00fan precio de competidor coincide con los filtros actuales.",
    "Competitor room": "Habitaci\u00f3n competidor",
    "Standard type": "Tipo est\u00e1ndar",
    "My room categories": "Mis categor\u00edas",
    Competitor: "Competidor",
    "Competitor hotel": "Hotel competidor",
    Weight: "Peso",
    mapped: "mapeadas",
    "Meal plans": "Planes de comidas",
    "Rate conditions": "Condiciones tarifarias",
    "(none)": "(ninguno)",
    Standard: "Est\u00e1ndar",
    Unmapped: "Sin mapear",
    "Not mapped yet": "Todav\u00eda sin mapear",
    "No own room category linked yet": "A\u00fan no hay una categor\u00eda propia vinculada",
    "Price shown": "Precio mostrado",
    "Price / night": "Precio / noche",
    "Estimated / night": "Estimado / noche",
    "Observed / night": "Observado / noche",
    "Verified with 1-night prices": "Verificado con precios de 1 noche",
    "Estimate from the average nightly prices of 2-night stays that include this date.":
      "Estimación a partir de las medias por noche de las estancias de 2 noches que incluyen esta fecha.",
    "Nightly price verified using 1-night quotes and a matching 2-night stay.":
      "Precio por noche verificado con precios de 1 noche y una estancia de 2 noches cuyo total coincide.",
    "{count} stays used": "{count} estancias utilizadas",
    "Average nightly price range": "Rango de las medias por noche",
    "Source stay": "Estancia consultada",
    "Source stay total": "Total de la estancia consultada",
    "Source stay average / night": "Media por noche de la estancia consultada",
    "Stay length": "Duración de la estancia",
    "All stay lengths": "Todas las duraciones",
    Promotion: "Promoción",
    Payment: "Pago",
    Taxes: "Impuestos",
    "Select an offer. Prices are shown per night; estimates are marked and explained in the price detail.":
      "Selecciona una oferta. Los precios se muestran por noche; los estimados se identifican y se explican en el detalle del precio.",
    "Meal plan": "Plan de comidas",
    "Click to open source": "Haz clic para abrir la fuente",
    "pax not set": "pax sin definir",
    "pax n/a": "pax n/d",
    "LOS n/a": "LOS n/d",
    "All competitors": "Todos los competidores",
    "Search options...": "Buscar opciones...",
    "No options match this search.": "Ninguna opci\u00f3n coincide con esta b\u00fasqueda.",
    "Showing {from} to {to}": "Mostrando de {from} a {to}",
    "Could not load market benchmark.":
      "No se ha podido cargar el benchmark de mercado.",
    "Competitor prices grouped by hotel and competitor room type.":
      "Precios de competidores agrupados por hotel y tipo de habitaci\u00f3n del competidor.",
    "Room types": "Tipos de habitaci\u00f3n",
    "Mapped lines": "L\u00edneas mapeadas",
    "Latest snapshot": "\u00daltima captura",
    "Hotels visible with the current filters":
      "Hoteles visibles con los filtros actuales",
    "Competitor room lines in this date range":
      "L\u00edneas de habitaciones competidoras en este rango",
    "Room lines already linked to an RMS standard type":
      "L\u00edneas ya vinculadas a un tipo est\u00e1ndar RMS",
    "Most recent market extraction shown here":
      "Extracci\u00f3n de mercado m\u00e1s reciente mostrada aqu\u00ed",
    "Choose which meal plans should stay visible in the benchmark.":
      "Elige qu\u00e9 planes de comidas deben seguir visibles en el benchmark.",
    "Choose which rate plans or cancellation conditions should stay visible.":
      "Elige qu\u00e9 tarifas o condiciones de cancelaci\u00f3n deben seguir visibles.",
    "Market pricing workspace": "Espacio de precios de mercado",
    "Observed prices": "Precios observados",
    "See raw competitor offers": "Consulta ofertas directas de competidores",
    "Create reference": "Crear referencia",
    "Saved references": "Referencias guardadas",
    "Review or apply later": "Revisar o aplicar m\u00e1s adelante",
    "Select exact offers": "Selecciona ofertas exactas",
    "{count} offers selected": "{count} ofertas seleccionadas",
    "Raw competitor prices. Each row is one exact source, room, occupancy, LOS, meal plan and rate condition.":
      "Precios directos de la competencia. Cada fila representa una fuente, habitaci\u00f3n, ocupaci\u00f3n, LOS, plan de comidas y condici\u00f3n tarifaria exactos.",
    "Exact offers": "Ofertas exactas",
    "Separate source, room, occupancy, LOS and rate conditions":
      "Fuente, habitaci\u00f3n, ocupaci\u00f3n, LOS y condiciones separados",
    "Mapped offers": "Ofertas mapeadas",
    "Offers already linked to an RMS standard type":
      "Ofertas ya vinculadas a un tipo est\u00e1ndar RMS",
    "Select the exact competitor offers you want to use":
      "Selecciona las ofertas exactas de competidores que quieres utilizar",
    "Use the checkbox beside a room offer. Nothing is averaged or transformed on this screen.":
      "Usa la casilla junto a cada oferta. En esta pantalla no se promedia ni transforma nada.",
    "{count} exact offers selected": "{count} ofertas exactas seleccionadas",
    "These offers will be preserved individually in the market reference.":
      "Estas ofertas se conservar\u00e1n individualmente en la referencia de mercado.",
    "Create reference with selection": "Crear referencia con la selecci\u00f3n",
    "Competitor offer": "Oferta del competidor",
    "{count} exact offers": "{count} ofertas exactas",
    "Unknown source": "Fuente desconocida",
    "No meal plan": "Sin plan de comidas",
    "No rate conditions": "Sin condiciones tarifarias",
    "Create a market price reference": "Crear una referencia de precios de mercado",
    "Choose exact competitor offers, combine them and decide how your own rate should be positioned.":
      "Elige ofertas exactas de competidores, comb\u00ednalas y decide c\u00f3mo debe posicionarse tu propia tarifa.",
    "Manual mode": "Modo manual",
    "Competitor offers": "Ofertas de competidores",
    "Only the exact offers selected in Observed prices are used.":
      "Solo se utilizan las ofertas exactas seleccionadas en Precios observados.",
    "Go to Observed prices and select at least one competitor offer.":
      "Ve a Precios observados y selecciona al menos una oferta de competidor.",
    "Remove {name}": "Quitar {name}",
    "Destination and dates": "Destino y fechas",
    "Choose the base room rate whose prices may be changed.":
      "Elige la tarifa base cuyos precios podr\u00e1n modificarse.",
    "Reference name": "Nombre de la referencia",
    "Example: Flexible BAR vs direct competitors":
      "Ejemplo: BAR flexible frente a competidores directos",
    "Destination room rate": "Tarifa de habitaci\u00f3n de destino",
    "No base room rates available": "No hay tarifas base disponibles",
    From: "Desde",
    To: "Hasta",
    "Allowed range": "Rango permitido",
    Calculation: "C\u00e1lculo",
    "First combine the market prices, then place your own rate relative to that result.":
      "Primero combina los precios de mercado y despu\u00e9s posiciona tu tarifa respecto a ese resultado.",
    "Combine competitor prices using": "Combinar precios de competidores mediante",
    Average: "Promedio",
    Minimum: "M\u00ednimo",
    Maximum: "M\u00e1ximo",
    "Position my price": "Posicionar mi precio",
    "Equal to the reference": "Igual a la referencia",
    "Above the reference": "Por encima de la referencia",
    "Below the reference": "Por debajo de la referencia",
    "Adjustment type": "Tipo de ajuste",
    "Fixed amount": "Importe fijo",
    Percent: "Porcentaje",
    "Adjustment value": "Valor del ajuste",
    "Nothing changes until you press Save and apply.":
      "Nada cambia hasta que pulses Guardar y aplicar.",
    "Preview and Save reference are read-only for your room prices.":
      "Previsualizar y Guardar referencia no modifican los precios de tus habitaciones.",
    "Preview result": "Previsualizar resultado",
    "Calculating...": "Calculando...",
    "Preview before applying": "Previsualizaci\u00f3n antes de aplicar",
    "Ready to review": "Listo para revisar",
    "My current price": "Mi precio actual",
    "Combined reference": "Referencia combinada",
    "Resulting price": "Precio resultante",
    Coverage: "Cobertura",
    Application: "Aplicaci\u00f3n",
    "Market price comparison chart": "Gr\u00e1fico comparativo de precios de mercado",
    "{method}, with no adjustment": "{method}, sin ajuste",
    "{method}, {value}{suffix} {direction}": "{method}, {value}{suffix} {direction}",
    above: "por encima",
    below: "por debajo",
    "days with market price": "d\u00edas con precio de mercado",
    "Review the curve and daily values before deciding.":
      "Revisa la curva y los valores diarios antes de decidir.",
    "Save keeps the snapshot for later. Save and apply writes the resulting prices now.":
      "Guardar conserva la captura para m\u00e1s adelante. Guardar y aplicar escribe ahora los precios resultantes.",
    "Save reference": "Guardar referencia",
    "Reference saved": "Referencia guardada",
    "Save and apply prices": "Guardar y aplicar precios",
    "Preparing application...": "Preparando aplicaci\u00f3n...",
    "Applying {completed}/{total}...": "Aplicando {completed}/{total}...",
    "Select at least one exact competitor offer.":
      "Selecciona al menos una oferta exacta de competidor.",
    "Select a destination room rate.": "Selecciona una tarifa de destino.",
    "Select a valid date range.": "Selecciona un rango de fechas v\u00e1lido.",
    "Could not load destination room rates.":
      "No se han podido cargar las tarifas de destino.",
    "Could not calculate the market reference.":
      "No se ha podido calcular la referencia de mercado.",
    "You do not have permission to save or apply market prices.":
      "No tienes permiso para guardar o aplicar precios de mercado.",
    "Preview the result before saving it.":
      "Previsualiza el resultado antes de guardarlo.",
    "Could not save the market reference.":
      "No se ha podido guardar la referencia de mercado.",
    "The market reference was saved without changing prices.":
      "La referencia de mercado se ha guardado sin modificar precios.",
    "The reference was saved and its prices were applied.":
      "La referencia se ha guardado y sus precios se han aplicado.",
    "The reference was saved, but {count} dates could not be applied.":
      "La referencia se ha guardado, pero no se han podido aplicar {count} fechas.",
    "Saved market references": "Referencias de mercado guardadas",
    "Each reference preserves the competitor offers, calculation and daily snapshot used at that moment.":
      "Cada referencia conserva las ofertas de competidores, el c\u00e1lculo y la captura diaria utilizados en ese momento.",
    Reference: "Referencia",
    "Loading saved market references...": "Cargando referencias de mercado guardadas...",
    "No market references have been saved yet.":
      "Todav\u00eda no se ha guardado ninguna referencia de mercado.",
    "Loading reference detail...": "Cargando detalle de la referencia...",
    "Could not load saved market references.":
      "No se han podido cargar las referencias de mercado guardadas.",
    "Could not load this market reference.":
      "No se ha podido cargar esta referencia de mercado.",
    "Apply saved prices": "Aplicar precios guardados",
    "Retry pending prices": "Reintentar precios pendientes",
    "All pending prices in this reference were applied.":
      "Se han aplicado todos los precios pendientes de esta referencia.",
    "The reference remains partially applied: {count} dates failed.":
      "La referencia sigue aplicada parcialmente: han fallado {count} fechas.",
    "Could not apply this market reference.":
      "No se ha podido aplicar esta referencia de mercado.",
    draft: "borrador",
    applied: "aplicada",
    partially_applied: "aplicada parcialmente",
    unavailable: "sin precio",
    failed: "fallida",
    "Not mapped": "Sin mapear",
    "Not linked yet": "A\u00fan sin vincular",
    Closed: "Cerrado",
    "Match your room categories and competitor room types to the shared standard market types.":
      "Relaciona tus categor\u00edas de habitaci\u00f3n y los tipos de habitaci\u00f3n de competidores con los tipos est\u00e1ndar compartidos del mercado.",
    "Loading mapping studio...": "Cargando estudio de mapeo...",
    "No standard market types are available yet.":
      "A\u00fan no hay tipos de mercado est\u00e1ndar disponibles.",
    "Your hotel": "Tu hotel",
    "Shared market types": "Tipos de mercado compartidos",
    "Standard room types": "Tipos de habitaci\u00f3n est\u00e1ndar",
    "{count} pax view": "Vista para {count} pax",
    "Choose a standard row for the selected room, or drag it there.":
      "Elige una fila est\u00e1ndar para la habitaci\u00f3n seleccionada o arr\u00e1strala hasta ella.",
    "Drag an unassigned room into its comparable standard row.":
      "Arrastra una habitaci\u00f3n sin asignar hasta su fila est\u00e1ndar comparable.",
    "Own mapped": "Habitaciones propias asignadas",
    "Competitor mapped": "Habitaciones competidoras asignadas",
    "Each row is one comparable market family.":
      "Cada fila representa una familia de mercado comparable.",
    "Drop a room here to start mapping.":
      "Arrastra una habitaci\u00f3n aqu\u00ed para empezar a asignarla.",
    "Selected room details": "Detalles de la habitaci\u00f3n seleccionada",
    "Showing now": "Mostrando ahora",
    Own: "Propio",
    Competition: "Competencia",
    "Competitor room types": "Tipos de habitaci\u00f3n de competidores",
    "Click any small card to see its details here.":
      "Haz clic en cualquier tarjeta peque\u00f1a para ver aqu\u00ed sus detalles.",
    "Own room category": "Categor\u00eda propia",
    "Competitor room type": "Tipo de habitaci\u00f3n competidor",
    "Current standard type": "Tipo est\u00e1ndar actual",
    "Not assigned yet": "A\u00fan sin asignar",
    "Comparable guests": "Huespedes comparables",
    "Standard default": "Valor est\u00e1ndar",
    "Pick a standard type first": "Primero elige un tipo est\u00e1ndar",
    "Save guests": "Guardar hu\u00e9spedes",
    "Send to unassigned": "Enviar a no asignados",
    "Market options found": "Opciones de mercado encontradas",
    "Normalized name": "Nombre normalizado",
    "No guest options found yet": "Todav\u00eda no se han encontrado opciones de hu\u00e9spedes",
    "Pick pax": "Elegir pax",
    "Hotel capacity: {capacity}": "Capacidad hotel: {capacity}",
    "Market options: {range}": "Opciones mercado: {range}",
    "This category will only compare against market rows that share the same standard type and the same comparable guest count.":
      "Esta categor\u00eda solo se comparar\u00e1 con filas de mercado que compartan el mismo tipo est\u00e1ndar y el mismo n\u00famero comparable de hu\u00e9spedes.",
    "This competitor type will only count for market comparison when both the standard type and the comparable guest count match your own category.":
      "Este tipo de competidor solo contar\u00e1 para la comparaci\u00f3n de mercado cuando tanto el tipo est\u00e1ndar como el n\u00famero comparable de hu\u00e9spedes coincidan con tu categor\u00eda.",
    "You do not have permission to edit this setup.":
      "No tienes permiso para editar esta configuraci\u00f3n.",
    "Define how the optimizer should understand your hotel, your room categories, your comparable market and your demand context.":
      "Define c\u00f3mo debe entender el optimizador tu hotel, tus categor\u00edas, tu mercado comparable y tu contexto de demanda.",
    "Tell the RMS how strong your hotel quality signal is when compared with the market.":
      "Indica al RMS cu\u00e1n fuerte es la se\u00f1al de calidad de tu hotel frente al mercado.",
    "Save quality settings": "Guardar ajustes de calidad",
    "These values do not set prices directly. They only tell the RMS how much hotel quality should matter when it compares your hotel with competitors.":
      "Estos valores no fijan precios directamente. Solo indican al RMS cu\u00e1nto debe pesar la calidad del hotel al compararlo con competidores.",
    "Current public review score": "Puntuaci\u00f3n p\u00fablica actual",
    "Number of reviews": "N\u00famero de rese\u00f1as",
    "Price impact for 1 review point": "Impacto en precio por 1 punto de rese\u00f1a",
    "Maximum quality impact": "Impacto m\u00e1ximo de calidad",
    pax: "pax",
    adult: "adulto",
    adults: "adultos",
    child: "ni\u00f1o",
    children: "ni\u00f1os",
    total: "total",
    "Could not load competitor room types.":
      "No se han podido cargar los tipos de habitaci\u00f3n de competidores.",
    "Comparable guests for {name} must be greater than 0.":
      "Los hu\u00e9spedes comparables para {name} deben ser mayores que 0.",
    "{name} only has market rows for {options}.":
      "{name} solo tiene filas de mercado para {options}.",
    "No category assigned": "Ninguna categor\u00eda asignada",
    "No competitor type assigned": "Ning\u00fan tipo de competidor asignado",
    "Review which hotels are in your market scope and decide how strongly each one should influence the RMS.":
      "Revisa qu\u00e9 hoteles est\u00e1n en tu alcance de mercado y decide cu\u00e1nto deben influir en el RMS.",
    "Loading competitors...": "Cargando competidores...",
    "No competitor hotels are available yet in the market extraction scope.":
      "Todav\u00eda no hay hoteles competidores disponibles en el alcance de extracci\u00f3n del mercado.",
    "Adjust competitor": "Ajustar competidor",
    "Room categories mapped": "Categor\u00edas mapeadas",
    "still without mapping": "todav\u00eda sin mapear",
    "No categories found": "No se han encontrado categor\u00edas",
    "Active strategies": "Estrategias activas",
    "Hotel-level and category-level posture":
      "Postura a nivel hotel y a nivel categor\u00eda",
    "Active competitors": "Competidores activos",
    "currently ignored": "ignorados actualmente",
    "No competitor scope configured": "No hay alcance de competidores configurado",
    "active disruptions": "disrupciones activas",
    Actions: "Acciones",
    "Advanced edit": "Edici\u00f3n avanzada",
    "Delete row #{id} from {title}?": "\u00bfEliminar la fila #{id} de {title}?",
    "Standard Room Types": "Tipos de habitaci\u00f3n est\u00e1ndar",
    "Comparable types used only for market matching.":
      "Tipos comparables usados solo para emparejar mercado.",
    "Room Category Mappings": "Mapeos de categor\u00edas",
    "Internal category to standard type mapping for market comparison.":
      "Mapeo de categor\u00eda interna a tipo est\u00e1ndar para comparaci\u00f3n de mercado.",
    "Strategy Settings": "Ajustes de estrategia",
    "Hotel or room-category strategy rules.": "Reglas de estrategia a nivel hotel o categor\u00eda.",
    "Competitor Room Type Mappings": "Mapeos de tipos de habitaci\u00f3n competidor",
    "Normalization of competitor room names into standard types and comparable guests.":
      "Normalizaci\u00f3n de nombres de habitaciones de competidores a tipos est\u00e1ndar y hu\u00e9spedes comparables.",
    "Seasonality Templates": "Plantillas de estacionalidad",
    "Reusable demand templates.": "Plantillas reutilizables de demanda.",
    "Seasonality Periods": "Periodos de estacionalidad",
    "Date ranges assigned to one template.": "Rangos de fechas asignados a una plantilla.",
    "Seasonality Profiles": "Perfiles de estacionalidad",
    "Expected demand or pricing behavior by room category and day of week.":
      "Demanda esperada o comportamiento de pricing por categor\u00eda y d\u00eda de la semana.",
    "Market Disruptions": "Disrupciones de mercado",
    "Short-term shocks that should make the RMS firmer or softer than normal.":
      "Impactos de corto plazo que deben volver el RMS m\u00e1s firme o m\u00e1s suave de lo normal.",
    "Add strategy": "A\u00f1adir estrategia",
    "Edit strategy": "Editar estrategia",
    "Edit template": "Editar plantilla",
    "Edit period": "Editar periodo",
    "Edit profile": "Editar perfil",
    "Edit disruption": "Editar disrupci\u00f3n",
    "Could not save RMS quality settings.":
      "No se han podido guardar los ajustes de calidad RMS.",
    "Could not save competitor settings.":
      "No se han podido guardar los ajustes del competidor.",
    "Could not save RMS resource.": "No se ha podido guardar el recurso RMS.",
    "Could not delete RMS resource.": "No se ha podido eliminar el recurso RMS.",
    Occupancy: "Ocupación",
    LOS: "LOS",
    "Code {code}": "Código {code}",
    "{count} room types": "{count} tipos de habitación",
    "{count} mapped": "{count} mapeados",
    "You are classifying {count} pax now. Only cards that belong to {count} pax are shown in the middle, and the selected card can be dropped into one of the standard boxes.":
      "Ahora estás clasificando {count} pax. Solo se muestran en el centro las tarjetas que pertenecen a {count} pax, y la tarjeta seleccionada puede soltarse en una de las cajas estándar.",
    "You are classifying {count} pax now. Only cards that belong to {count} pax are shown in the middle. Drag a small card into one of the standard boxes in the middle.":
      "Ahora estás clasificando {count} pax. Solo se muestran en el centro las tarjetas que pertenecen a {count} pax. Arrastra una tarjeta pequeña a una de las cajas estándar del centro.",
    "Cards only appear here when they can be classified for the pax you are viewing now.":
      "Las tarjetas solo aparecen aquí cuando pueden clasificarse para los pax que estás viendo ahora.",
    "category available": "categoría disponible",
    "categories available": "categorías disponibles",
    "type available": "tipo disponible",
    "types available": "tipos disponibles",
    "No room category is waiting to be classified for {count} pax.":
      "No hay ninguna categoría de habitación pendiente de clasificar para {count} pax.",
    "The middle box defines the market family. The selector here changes the active pax view used to classify cards.":
      "La caja central define la familia de mercado. El selector cambia la vista activa de pax usada para clasificar tarjetas.",
    "No competitor room type is waiting to be classified for {count} pax.":
      "No hay ningún tipo de habitación competidor pendiente de clasificar para {count} pax.",
    days: "días",
    index: "índice",
    "Template default": "Valor por defecto de la plantilla",
    "Full confidence": "Confianza total",
    "Choose a season": "Elige una temporada",
    "Priority {value}": "Prioridad {value}",
    "Choose a room category": "Elige una categoría de habitación",
    "Custom demand tone": "Tono de demanda personalizado",
    "Demand tone": "Tono de demanda",
    "Template demand tone": "Tono de demanda de la plantilla",
    "Choose a disruption type": "Elige un tipo de disrupción",
    "Choose direction": "Elige una dirección",
    "Choose strength": "Elige una intensidad",
    "This period runs from {from} to {to}.":
      "Este periodo va de {from} a {to}.",
    "Loading {title}...": "Cargando {title}...",
    "No rows yet for {title}.": "Todavía no hay filas para {title}.",
    "This list is controlled by your market data extraction scope. It is read-only here, so this screen does not add or remove competitor hotels.":
      "Esta lista la controla el alcance de extracción de datos de mercado. Aquí es de solo lectura, por lo que esta pantalla no añade ni elimina hoteles competidores.",
    "What you can control here is how much each competitor matters in the RMS benchmark, and whether a competitor should influence the optimizer right now.":
      "Aquí puedes controlar cuánto pesa cada competidor en el benchmark RMS y si debe influir en el optimizador ahora mismo.",
    "Extraction scope": "Alcance de extracción",
    "Not configured yet": "Aún no configurado",
    "Currency: {currency}": "Moneda: {currency}",
    "No market scope has been loaded yet.":
      "Aún no se ha cargado ningún alcance de mercado.",
    Sources: "Fuentes",
    "No sources detected": "No se han detectado fuentes",
    "{count} source feeding this benchmark": "{count} fuente alimenta este benchmark",
    "{count} sources feeding this benchmark": "{count} fuentes alimentan este benchmark",
    "Sources are missing from the extraction scope.":
      "Faltan fuentes en el alcance de extracción.",
    "Competitors in scope": "Competidores en alcance",
    "{count} currently influence the RMS": "{count} influyen actualmente en el RMS",
    "Hotel code {code}": "Código de hotel {code}",
    "Influences RMS": "Influye en el RMS",
    "Ignored by RMS": "Ignorado por el RMS",
    "Custom settings": "Ajustes personalizados",
    "Default settings": "Ajustes por defecto",
    "Address stored in the extraction scope is not available.":
      "La dirección guardada en el alcance de extracción no está disponible.",
    Importance: "Importancia",
    Distance: "Distancia",
    "Public rating": "Valoración pública",
    Reviews: "Reseñas",
    "Not set": "Sin definir",
    "This hotel currently contributes to your market benchmark.":
      "Este hotel contribuye actualmente a tu benchmark de mercado.",
    "This hotel stays in the scope, but the RMS ignores it until you activate it again.":
      "Este hotel sigue dentro del alcance, pero el RMS lo ignora hasta que lo actives de nuevo.",
    "Decide how much this hotel should influence your market benchmark.":
      "Decide cuánto debe influir este hotel en tu benchmark de mercado.",
    "Competitor in extraction scope": "Competidor dentro del alcance de extracción",
    "Address not available": "Dirección no disponible",
    "1. How important should this competitor be?":
      "1. ¿Qué importancia debe tener este competidor?",
    "Use a bigger number when this hotel is one of your closest real references. Keep it smaller when it is only a secondary reference.":
      "Usa un número mayor cuando este hotel sea una de tus referencias reales más cercanas. Déjalo más bajo cuando solo sea una referencia secundaria.",
    "Importance in market benchmark": "Importancia en el benchmark de mercado",
    "Example: 1 means normal importance, 2 means this hotel counts about twice as much, and 0.5 means it counts about half as much.":
      "Ejemplo: 1 significa importancia normal, 2 significa que este hotel cuenta aproximadamente el doble y 0.5 significa que cuenta aproximadamente la mitad.",
    "2. Optional reference details": "2. Datos de referencia opcionales",
    "These details help you review the competitor set with more context. Leave them empty if you do not need them.":
      "Estos datos te ayudan a revisar el set competitivo con más contexto. Déjalos vacíos si no los necesitas.",
    "Distance from your hotel": "Distancia desde tu hotel",
    "Optional. A nearby hotel is often a stronger reference than one that is much farther away.":
      "Opcional. Un hotel cercano suele ser una referencia más fuerte que uno mucho más lejano.",
    "Public review score": "Puntuación pública de reseñas",
    "Optional. This helps you remember whether the competitor is positioned above, below or close to your hotel in public perception.":
      "Opcional. Esto te ayuda a recordar si el competidor está por encima, por debajo o cerca de tu hotel en percepción pública.",
    "Optional. More reviews usually make that public rating more trustworthy.":
      "Opcional. Más reseñas suelen hacer que esa valoración pública sea más fiable.",
    "3. Should this competitor influence the RMS now?":
      "3. ¿Debe influir este competidor en el RMS ahora?",
    "Turn the competitor off when you want to keep it in scope but temporarily exclude it from the market benchmark.":
      "Desactiva el competidor cuando quieras mantenerlo en alcance pero excluirlo temporalmente del benchmark de mercado.",
    "This competitor currently influences the RMS":
      "Este competidor influye actualmente en el RMS",
    "This competitor is currently ignored by the RMS":
      "Este competidor está actualmente ignorado por el RMS",
    "Keep this on when the hotel is a valid benchmark reference.":
      "Mantén esto activado cuando el hotel sea una referencia válida para el benchmark.",
    "Turn this back on when you want its prices to count again.":
      "Vuelve a activarlo cuando quieras que sus precios vuelvan a contar.",
    "Whole hotel": "Hotel completo",
    "One room category": "Una categoría de habitación",
    "Fill rooms": "Llenar habitaciones",
    "Protect price": "Proteger precio",
    "Balanced": "Equilibrado",
    "Use season blocks": "Usar bloques de temporada",
    "Use calendar blocks": "Usar bloques de calendario",
    "Calendar ranges": "Rangos de calendario",
    "Quiet season": "Temporada tranquila",
    "Steady season": "Temporada estable",
    "Busy season": "Temporada activa",
    "Peak season": "Temporada pico",
    "Background season": "Temporada base",
    "Normal priority": "Prioridad normal",
    "Special override": "Override especial",
    "Every day": "Cada día",
    Monday: "Lunes",
    Tuesday: "Martes",
    Wednesday: "Miércoles",
    Thursday: "Jueves",
    Friday: "Viernes",
    Saturday: "Sábado",
    Sunday: "Domingo",
    "Local event": "Evento local",
    "Transport issue": "Incidencia de transporte",
    "Weather issue": "Incidencia meteorológica",
    "Works nearby": "Obras cercanas",
    Restriction: "Restricción",
    "Market shock": "Shock de mercado",
    Other: "Otro",
    "Push prices up": "Empujar precios al alza",
    "Push prices down": "Empujar precios a la baja",
    "Low effect": "Efecto bajo",
    "Medium effect": "Efecto medio",
    "High effect": "Efecto alto",
    "Severe effect": "Efecto severo",
    for: "para",
    "This rule will only affect the selected room category.":
      "Esta regla solo afectará a la categoría de habitación seleccionada.",
    "This rule will affect every room category unless a more specific room-category rule exists.":
      "Esta regla afectará a todas las categorías de habitación salvo que exista una regla más específica por categoría.",
    "Long-range blocks are currently set to {label}.":
      "Los bloques de largo plazo están configurados actualmente como {label}.",
    "Reusable season template": "Plantilla de temporada reutilizable",
    "Season name": "Nombre de la temporada",
    "Short note": "Nota breve",
    "Custom label": "Etiqueta personalizada",
    "Default price index": "Índice de precio por defecto",
    "Calendar season rule": "Regla de temporada de calendario",
    "Season template": "Plantilla de temporada",
    "Choose a season template": "Elige una plantilla de temporada",
    "Start date": "Fecha de inicio",
    "End date": "Fecha de fin",
    "Custom priority": "Prioridad personalizada",
    "Priority number": "Número de prioridad",
    "Season refinement rule": "Regla de refinamiento de temporada",
    "Day of week": "Día de la semana",
    "Keep template demand tone": "Mantener tono de demanda de la plantilla",
    "Price index override": "Override de índice de precio",
    "Expected occupancy": "Ocupación esperada",
    "Temporary market shock": "Impacto temporal de mercado",
    "Disruption name": "Nombre de la disrupción",
    "Confidence in this estimate": "Confianza en esta estimación",
    Source: "Fuente",
    Notes: "Notas",
    "What this rule is doing": "Qué está haciendo esta regla",
    "Target occupancy": "Ocupación objetivo",
    "Minimum average daily rate": "Tarifa media diaria mínima",
    "Desired price position vs market": "Posición de precio deseada frente al mercado",
    "Lowest allowed price": "Precio mínimo permitido",
    "Highest allowed price": "Precio máximo permitido",
    "Allow shorter minimum stays": "Permitir estancias mínimas más cortas",
    "Allow longer minimum stays": "Permitir estancias mínimas más largas",
    "Shortest minimum stay allowed": "Estancia mínima más corta permitida",
    "Longest minimum stay allowed": "Estancia mínima más larga permitida",
    "Daily recommendation horizon": "Horizonte diario de recomendación",
    "Shortest long-range period": "Periodo mínimo de largo plazo",
    "Use this strategy now": "Usar esta estrategia ahora",
    "Create strategy": "Crear estrategia",
    "Save strategy": "Guardar estrategia",
    "Create row": "Crear fila",
    "Save changes": "Guardar cambios",
    "Save disruption": "Guardar disrupción",
    "Advanced configuration editor for this section.":
      "Editor de configuración avanzada para este apartado.",
    "Tell the optimizer where this rule applies, what it should prioritize and which limits it must respect.":
      "Indica al optimizador dónde se aplica esta regla, qué debe priorizar y qué límites debe respetar.",
    "{count}-day daily view": "Vista diaria de {count} días",
    "Active now": "Activa ahora",
    "Saved as inactive": "Guardada como inactiva",
    "Start with one whole-hotel rule, then add category rules only where you really want different behavior. Keep only one active rule per room category.":
      "Empieza con una regla para todo el hotel y añade reglas por categoría solo cuando realmente necesites un comportamiento diferente. Mantén una sola regla activa por categoría de habitación.",
    "1. Where should this rule apply?": "1. ¿Dónde debe aplicarse esta regla?",
    "Start by choosing whether this rule is for the whole hotel or for one room category only.":
      "Elige primero si esta regla se aplica a todo el hotel o solo a una categoría de habitación.",
    "Use one single pricing posture for the whole hotel.":
      "Aplica una única estrategia de precios a todo el hotel.",
    "Use a different posture for one specific room category.":
      "Aplica una estrategia diferente a una categoría de habitación concreta.",
    "Use this when one room category needs a different strategy than the rest of the hotel.":
      "Utiliza esta opción cuando una categoría de habitación necesite una estrategia diferente al resto del hotel.",
    "2. What should the optimizer prioritize?": "2. ¿Qué debe priorizar el optimizador?",
    "Pick the commercial goal that best describes how you want this rule to behave.":
      "Elige el objetivo comercial que mejor describa cómo quieres que se comporte esta regla.",
    "The optimizer will be more willing to move price to improve occupancy.":
      "El optimizador estará más dispuesto a ajustar el precio para mejorar la ocupación.",
    "The optimizer will defend average daily rate even if it sells a bit slower.":
      "El optimizador defenderá la tarifa media diaria aunque el ritmo de venta sea algo más lento.",
    "The optimizer will try to balance occupancy and average price.":
      "El optimizador intentará equilibrar la ocupación y el precio medio.",
    "3. Price guardrails": "3. Límites de precio",
    "These limits keep recommendations inside your commercial comfort zone. Leave a field empty if you do not want to force that rule.":
      "Estos límites mantienen las recomendaciones dentro de tu margen comercial. Deja un campo vacío si no quieres imponer ese límite.",
    "Optional. Example: 78 means the RMS will try to finish around 78% occupancy.":
      "Opcional. Por ejemplo, 78 indica que el RMS intentará terminar cerca del 78 % de ocupación.",
    "Optional. Use this to defend the average selling level that this strategy should achieve across its dates. It tells the RMS to keep the overall price posture healthy, even if some individual days move differently.":
      "Opcional. Utilízalo para defender el nivel medio de venta que esta estrategia debe alcanzar en sus fechas. Indica al RMS que mantenga una posición general de precio saludable, aunque algunos días concretos varíen.",
    "This field is only available in room-category rules, so it does not push every category in the hotel to the same minimum.":
      "Este campo solo está disponible en reglas por categoría de habitación, para evitar imponer el mismo mínimo a todas las categorías del hotel.",
    "Optional. 100 means match the market. 105 means aim about 5% above. 95 means aim about 5% below.":
      "Opcional. 100 significa igualar el mercado; 105, situarse aproximadamente un 5 % por encima; y 95, un 5 % por debajo.",
    "Optional absolute safety floor. No single recommended day should go below this amount.":
      "Suelo de seguridad absoluto opcional. Ningún día recomendado debería quedar por debajo de este importe.",
    "This field is only available in room-category rules, so one hotel rule cannot set the same absolute minimum for all categories.":
      "Este campo solo está disponible en reglas por categoría de habitación, de modo que una regla de hotel no pueda fijar el mismo mínimo absoluto para todas las categorías.",
    "Optional hard ceiling. The RMS should not recommend a higher selling price than this.":
      "Techo máximo opcional. El RMS no debería recomendar un precio de venta superior a este importe.",
    "4. Minimum stay rules": "4. Reglas de estancia mínima",
    "Decide whether the RMS may tighten or relax minimum stay and how far it may go.":
      "Decide si el RMS puede endurecer o relajar la estancia mínima y hasta dónde puede hacerlo.",
    Allowed: "Permitido",
    Locked: "Bloqueado",
    "Turn this on if the RMS may reduce minimum stay to help fill softer dates.":
      "Actívalo si el RMS puede reducir la estancia mínima para ayudar a llenar las fechas con menor demanda.",
    "Turn this on if the RMS may increase minimum stay on stronger dates.":
      "Actívalo si el RMS puede aumentar la estancia mínima en fechas con mayor demanda.",
    "Lowest minimum stay the RMS may use. Example: 1 means one-night stays are allowed if the rule says so.":
      "Estancia mínima más corta que puede utilizar el RMS. Por ejemplo, 1 permite estancias de una noche cuando la regla lo indique.",
    "Highest minimum stay the RMS may use. This must be equal to or above the shortest minimum stay.":
      "Estancia mínima más larga que puede utilizar el RMS. Debe ser igual o superior a la estancia mínima más corta.",
    "5. How far ahead should the RMS guide prices?":
      "5. ¿Con cuánta antelación debe el RMS orientar los precios?",
    "First choose how many days get one exact recommendation per day. After that, the RMS groups future dates into longer periods and gives one guidance level for each period.":
      "Elige primero cuántos días recibirán una recomendación exacta por día. Después, el RMS agrupará las fechas futuras en periodos más largos y asignará un nivel de orientación a cada periodo.",
    "How many days ahead the RMS should recommend one exact price per day.":
      "Número de días futuros para los que el RMS debe recomendar un precio exacto por día.",
    "This is the shortest future period the RMS may group together after the daily horizon ends. Example: 7 means it can build weekly periods, but not tiny 2- or 3-day periods.":
      "Es el periodo futuro más corto que el RMS puede agrupar una vez terminado el horizonte diario. Por ejemplo, 7 permite crear periodos semanales, pero no periodos de solo 2 o 3 días.",
    "Build long-range guidance around your seasonality periods when they exist.":
      "Genera la orientación a largo plazo a partir de tus periodos de estacionalidad cuando existan.",
    "Build long-range guidance in regular calendar ranges.":
      "Genera la orientación a largo plazo mediante rangos regulares de calendario.",
    "Seasonality periods": "Periodos de estacionalidad",
    "6. Should this strategy be used now?": "6. ¿Debe utilizarse ahora esta estrategia?",
    "You can save a rule without activating it yet if you are still preparing your setup.":
      "Puedes guardar una regla sin activarla todavía si sigues preparando la configuración.",
    Active: "Activa",
    Inactive: "Inactiva",
    "Active strategies are used by the RMS. Inactive ones are saved for later and do not affect recommendations.":
      "El RMS utiliza las estrategias activas. Las inactivas se guardan para más adelante y no afectan a las recomendaciones.",
    "Configuration data": "Datos de configuración",
    "Recommended setup:": "Configuración recomendada:",
    "How decisions are made:": "Cómo se toman las decisiones:",
    "What a template is:": "Qué es una plantilla:",
    "How it is used later:": "Cómo se usa después:",
    "Tip:": "Consejo:",
    "What this section does:": "Qué hace esta sección:",
    "How priority works:": "Cómo funciona la prioridad:",
    "First create a season template": "Primero crea una plantilla de temporada",
    "What a profile is:": "Qué es un perfil:",
    "How it works:": "Cómo funciona:",
    "What this is for:": "Para qué sirve esto:",
    "Good examples:": "Buenos ejemplos:",
    "Decision order:": "Orden de decisión:",
    "What the RMS does:": "Qué hace el RMS:",
    "How the RMS uses strategy rules:": "Cómo usa el RMS las reglas de estrategia:",
    "Create one active rule for the whole hotel as your base strategy, then add extra active rules only for room categories that need different behavior.":
      "Crea una regla activa para todo el hotel como estrategia base y añade reglas activas extra solo para las categorías de habitación que necesiten un comportamiento distinto.",
    "Keep just one active rule per room category. The selected strategy influences the goal, price limits, minimum-stay freedom and planning horizon used by the RMS recommendation.":
      "Mantén una sola regla activa por categoría de habitación. La estrategia seleccionada influye en el objetivo, los límites de precio, la flexibilidad de la estancia mínima y el horizonte de planificación que utiliza la recomendación del RMS.",
    "The RMS uses the room-category rule first. If there is no active category rule, it uses the whole-hotel rule instead.":
      "El RMS usa primero la regla de categoría de habitación. Si no hay una regla activa por categoría, usa la regla de todo el hotel.",
    "One reusable season label such as low season, shoulder season or peak season.":
      "Una etiqueta de temporada reutilizable, como temporada baja, media o pico.",
    "In the next sections you assign date ranges to that template and, if needed, refine behavior by room type and day of week.":
      "En las siguientes secciones asignas rangos de fechas a esa plantilla y, si hace falta, refinas el comportamiento por tipo de habitación y día de la semana.",
    "Keep the templates broad and simple. A child should be able to understand the season names at first glance.":
      "Mantén las plantillas amplias y simples. Un niño debería poder entender los nombres de temporada a primera vista.",
    "Here you place each season template on the real calendar.":
      "Aquí colocas cada plantilla de temporada sobre el calendario real.",
    "If two periods overlap, the higher priority wins on those dates.":
      "Si dos periodos se solapan, la prioridad más alta gana en esas fechas.",
    "Use one normal-priority base season for most dates and only raise priority for special overrides such as fairs, Easter or local events.":
      "Usa una temporada base con prioridad normal para la mayoría de fechas y sube la prioridad solo para overrides especiales como ferias, Semana Santa o eventos locales.",
    "before adding date ranges here.": "antes de añadir aquí rangos de fechas.",
    "A refinement inside one season template.": "Un refinamiento dentro de una plantilla de temporada.",
    "First the RMS finds the season by date. Then it can refine that season for one of your room categories and, if needed, one day of the week.":
      "Primero el RMS identifica la temporada por fecha. Después puede refinar esa temporada para una de tus categorías de habitación y, si hace falta, para un día concreto de la semana.",
    "Create a profile only when one room category, or one weekday inside that room category, behaves differently from the main season.":
      "Crea un perfil solo cuando una categoría de habitación, o un día concreto dentro de esa categoría, se comporte de forma distinta a la temporada principal.",
    "before defining profile refinements.": "antes de definir refinamientos de perfil.",
    "Use disruptions for unusual situations that sit on top of normal seasonality, not instead of it.":
      "Usa disrupciones para situaciones poco habituales que se superponen a la estacionalidad normal, no para sustituirla.",
    "Each active disruption adds a temporary factor that makes the RMS firmer or softer during the chosen date range.":
      "Cada disrupción activa añade un factor temporal que hace que el RMS sea más firme o más flexible durante el rango de fechas elegido.",
    "A big concert week, a transport strike, major road works nearby or a sudden weather shock.":
      "Una semana de grandes conciertos, una huelga de transporte, obras importantes cerca o un shock meteorológico repentino.",
    "The RMS first identifies the season from `Seasonality Periods`, then looks here for a more specific refinement.":
      "El RMS identifica primero la temporada en `Seasonality Periods` y después busca aquí un refinamiento más específico.",
    "It turns each active disruption into a temporary price factor around 1.0 during the selected dates.":
      "Convierte cada disrupción activa en un factor temporal de precio alrededor de 1.0 durante las fechas seleccionadas.",
    "It first looks for one active rule for the room category. If it does not find one, it falls back to the active whole-hotel rule.":
      "Primero busca una regla activa para la categoría de habitación. Si no la encuentra, recurre a la regla activa de todo el hotel.",
    "Pricing products": "Productos tarifarios",
    Products: "Productos",
    "Choose the independent master room rate the RMS should optimize for every room category.":
      "Elige la tarifa maestra independiente que el RMS debe optimizar para cada categoría de habitación.",
    "Choose the independent master rate and verify every active product derives from it.":
      "Elige la tarifa maestra independiente y verifica que cada producto activo derive de ella.",
    "Complete when every room category has one active and valid master room rate policy.":
      "Se completa cuando cada categoría de habitación tiene una política de tarifa maestra activa y válida.",
    "Complete when every category has a valid master, product guardrails and executable derived-rate rules for the operating horizon.":
      "Se completa cuando cada categoría tiene una maestra válida, límites por producto y reglas derivadas ejecutables para el horizonte operativo.",
    "Master room rates": "Tarifas maestras",
    "The independent room rate optimized by the RMS for each room category.":
      "La tarifa independiente que optimiza el RMS para cada categoría de habitación.",
    "Master rates configured": "Tarifas maestras configuradas",
    "Product policies ready": "Políticas de producto listas",
    "{count} still without a ready product policy":
      "{count} todavía sin una política de producto lista",
    "Master and derived products ready for every room category":
      "Productos maestros y derivados listos para cada categoría de habitación",
    "{configured}/{total} product policies ready":
      "{configured}/{total} políticas de producto listas",
    "{count} still without a valid master rate":
      "{count} todavía sin una tarifa maestra válida",
    "Master rate ready for every room category":
      "Tarifa maestra lista para cada categoría de habitación",
    "{configured}/{total} master rates configured":
      "{configured}/{total} tarifas maestras configuradas",
    "Choose a master room rate for {category}.":
      "Elige una tarifa maestra para {category}.",
    "this room category": "esta categoría de habitación",
    "The selected master rate is not valid for this room category.":
      "La tarifa maestra seleccionada no es válida para esta categoría de habitación.",
    "Could not save the master room rate policy.":
      "No se ha podido guardar la política de tarifa maestra.",
    "Choose the one independent rate the RMS may optimize in each room category.":
      "Elige la única tarifa independiente que el RMS puede optimizar en cada categoría de habitación.",
    "{configured}/{total} configured": "{configured}/{total} configuradas",
    "What the RMS changes:": "Qué cambia el RMS:",
    "Recommendations target only the selected master rate. Derived non-refundable, meal, occupancy and channel products keep following their existing PMS rules.":
      "Las recomendaciones actúan solo sobre la tarifa maestra seleccionada. Los productos derivados no reembolsables, por régimen, ocupación y canal siguen sus reglas actuales del PMS.",
    "Safe selection:": "Selección segura:",
    "Only active independent rates from the same room category are available here.":
      "Aquí solo están disponibles tarifas independientes activas de la misma categoría de habitación.",
    "Loading master room rates...": "Cargando tarifas maestras...",
    "Master room rate": "Tarifa maestra",
    "Rate guardrails": "Límites de tarifa",
    "Derived products": "Productos derivados",
    "{traced}/{total} linked to master": "{traced}/{total} vinculados a la maestra",
    "Derivation check unavailable": "Comprobación de derivación no disponible",
    "Coverage: {from} to {to}": "Cobertura: {from} a {to}",
    "+{count} more issues": "+{count} incidencias más",
    "Master rate policy is missing": "Falta la política de tarifa maestra",
    "More than one active master policy was found":
      "Se ha encontrado más de una política maestra activa",
    "The selected master rate is not valid": "La tarifa maestra seleccionada no es válida",
    "The master rate does not cover the operating horizon":
      "La tarifa maestra no cubre el horizonte operativo",
    "This active rate is independent from the master":
      "Esta tarifa activa es independiente de la maestra",
    "The derived-rate chain contains a cycle":
      "La cadena de tarifas derivadas contiene un ciclo",
    "The derived-rate chain crosses room categories":
      "La cadena de tarifas derivadas cruza categorías de habitación",
    "A parent rate is missing": "Falta una tarifa padre",
    "A required parent rate is inactive": "Una tarifa padre necesaria está inactiva",
    "A synchronized master-group rate is missing":
      "Falta una tarifa sincronizada del grupo de la tarifa maestra",
    "A synchronized master-group rate is derived and cannot be used as a price seed":
      "Una tarifa sincronizada del grupo de la tarifa maestra es derivada y no puede usarse como origen de precio",
    "A downstream derived rate is missing":
      "Falta una tarifa derivada posterior en la cadena",
    "A synchronized master-group rate is inactive":
      "Una tarifa sincronizada del grupo de la tarifa maestra está inactiva",
    "A downstream derived rate is inactive":
      "Una tarifa derivada posterior en la cadena está inactiva",
    "A synchronized rate in this product group is inactive":
      "Una tarifa sincronizada de este grupo de productos está inactiva",
    "The rate has more than one derivation relationship":
      "La tarifa tiene más de una relación de derivación",
    "The formula has no input rates": "La fórmula no tiene tarifas de entrada",
    "The linked formula is missing": "Falta la fórmula vinculada",
    "This product needs its own floor and ceiling":
      "Este producto necesita sus propios precios mínimo y máximo",
    "This product has invalid floor or ceiling values":
      "Este producto tiene valores mínimo o máximo no válidos",
    "This product has no whole price between its floor and ceiling":
      "Este producto no tiene ningún precio entero entre su mínimo y su máximo",
    "This product has inconsistent default min/max stay restrictions for at least one weekday":
      "Este producto tiene restricciones predeterminadas de estancia mínima/máxima incoherentes en al menos un día de la semana",
    "The simple derived-rate adjustment is invalid":
      "El ajuste de la tarifa derivada simple no es válido",
    "The derived-rate formula is invalid": "La fórmula de tarifa derivada no es válida",
    "Custom derived formulas are not supported by RMS yet":
      "El RMS todavía no admite fórmulas derivadas personalizadas",
    "This derived product does not cover the operating horizon":
      "Este producto derivado no cubre el horizonte operativo",
    "A synchronized rate in this product group does not cover the operating horizon":
      "Una tarifa sincronizada de este grupo de productos no cubre el horizonte operativo",
    "This product has an invalid currency code; use a three-letter ISO code":
      "Este producto tiene un código de moneda no válido; usa un código ISO de tres letras",
    "This product uses a different currency from the master":
      "Este producto usa una moneda distinta de la tarifa maestra",
    "Synchronized rates in this product group use different currencies":
      "Las tarifas sincronizadas de este grupo de productos usan monedas distintas",
    "Synchronized rates in this product group have incompatible price limits":
      "Las tarifas sincronizadas de este grupo de productos tienen límites de precio incompatibles",
    "The derived-rate relationship is invalid":
      "La relación de tarifa derivada no es válida",
    Policy: "Política",
    "Master room rate for {category}": "Tarifa maestra para {category}",
    "Choose a master room rate": "Elige una tarifa maestra",
    "No independent active rates available":
      "No hay tarifas independientes activas disponibles",
    "Current selection is no longer available":
      "La selección actual ya no está disponible",
    "Create or activate an independent room rate with floor and ceiling for this category first.":
      "Primero crea o activa una tarifa independiente con precio mínimo y máximo para esta categoría.",
    "Version {version}": "Versión {version}",
    Product: "Producto",
    "Policy v{version}": "Política v{version}",
    Saved: "Guardada",
    "Save change": "Guardar cambio",
    "Save master rate": "Guardar tarifa maestra",
    "Unavoidable orphan-gap safeguards":
      "Salvaguardas para huecos inevitables",
    "Opt in by strategy for one- or two-night gaps. A T06 reassignment assessment is always required first, and dates beyond the configured horizon never receive an automatic orphan-gap discount.":
      "Actívalo por estrategia para huecos de una o dos noches. Siempre se exige antes una evaluación de reasignación T06 y las fechas posteriores al horizonte configurado nunca reciben un descuento automático por hueco.",
    "Save orphan-gap safeguards": "Guardar salvaguardas de huecos",
    "The saved orphan-gap safeguards need attention.":
      "Las salvaguardas de huecos guardadas requieren atención.",
    "Create a pricing strategy before configuring orphan-gap safeguards.":
      "Crea una estrategia de precios antes de configurar las salvaguardas de huecos.",
    "Orphan-gap configuration is unavailable.":
      "La configuración de huecos no está disponible.",
    "Strategy scope": "Ámbito de la estrategia",
    "Gap lengths": "Longitudes del hueco",
    "Automatic-discount horizon": "Horizonte de descuento automático",
    "Reassignment first": "Reasignación previa",
    "Use orphan-gap pricing": "Usar precios para huecos",
    "1 night": "1 noche",
    "2 nights": "2 noches",
    "Maximum 21 days; farther dates are protected.":
      "Máximo 21 días; las fechas más lejanas quedan protegidas.",
    "Mandatory T06 assessment": "Evaluación T06 obligatoria",
    "Could not save orphan-gap safeguards.":
      "No se han podido guardar las salvaguardas de huecos.",
    "There are no strategies to configure.": "No hay estrategias que configurar.",
    "Each strategy must appear exactly once.":
      "Cada estrategia debe aparecer exactamente una vez.",
    "Reassignment assessment must remain mandatory.":
      "La evaluación de reasignación debe seguir siendo obligatoria.",
    "The far horizon must be a whole number from 1 to 21 days.":
      "El horizonte lejano debe ser un número entero de 1 a 21 días.",
    "An enabled policy must include one-night or two-night gaps.":
      "Una política activa debe incluir huecos de una o dos noches.",
    "A disabled policy cannot retain enabled gap lengths.":
      "Una política desactivada no puede conservar longitudes de hueco activas.",
    "Near orphan-gap actions": "Acciones para huecos cercanos",
    "Within 0–7 days, an eligible T07 gap may relax MinLOS and propose a capped discount only with certified weak pace and complete economic clearance. Nothing is applied automatically.":
      "Entre 0 y 7 días, un hueco apto en T07 puede relajar la estancia mínima y proponer un descuento limitado solo con ritmo débil certificado y validación económica completa. Nada se aplica automáticamente.",
    "Save near-gap safeguards": "Guardar salvaguardas de huecos cercanos",
    "The saved near-gap safeguards need attention.":
      "Las salvaguardas de huecos cercanos guardadas requieren atención.",
    "Create a pricing strategy before configuring near-gap safeguards.":
      "Crea una estrategia de precios antes de configurar las salvaguardas de huecos cercanos.",
    "Near-gap configuration is unavailable.":
      "La configuración de huecos cercanos no está disponible.",
    "Near band": "Banda cercana",
    "MinLOS relaxation": "Relajación de estancia mínima",
    "Discount cap": "Límite de descuento",
    "Adjacent occupancy": "Ocupación adyacente",
    "Economic evidence": "Evidencia económica",
    "Safety gates": "Controles de seguridad",
    "0–{days} days": "0–{days} días",
    "Fixed horizon": "Horizonte fijo",
    "Use near-gap actions": "Usar acciones de hueco cercano",
    "Relax MinLOS": "Relajar estancia mínima",
    "MinLOS floor": "Mínimo de estancia",
    "1 night floor": "Mínimo de 1 noche",
    "2 night floor": "Mínimo de 2 noches",
    Currency: "Moneda",
    "Variable cost": "Coste variable",
    "Distribution cost": "Coste de distribución",
    "Hold current state": "Mantener estado actual",
    "Certified weak pace": "Ritmo débil certificado",
    "Economic clearance": "Validación económica",
    "T07 eligibility is required first.": "Antes se exige aptitud T07.",
    "Master-rate currency": "Moneda de la tarifa maestra",
    "Could not save near-gap safeguards.":
      "No se han podido guardar las salvaguardas de huecos cercanos.",
    "Each near-gap strategy must appear exactly once.":
      "Cada estrategia de hueco cercano debe aparecer exactamente una vez.",
    "Weak pace and economic clearance must remain mandatory.":
      "El ritmo débil y la validación económica deben seguir siendo obligatorios.",
    "The MinLOS floor must be one or two nights.":
      "El mínimo de estancia debe ser de una o dos noches.",
    "The near-gap discount cap must stay between 0 and 20%.":
      "El límite de descuento para huecos cercanos debe estar entre 0 y 20 %.",
    "Adjacent occupancy must stay between 0 and 100%.":
      "La ocupación adyacente debe estar entre 0 y 100 %.",
    "Economic evidence requires a three-letter currency code.":
      "La evidencia económica exige un código de moneda de tres letras.",
    "Variable occupied-room cost must be a non-negative amount.":
      "El coste variable por habitación ocupada no puede ser negativo.",
    "Distribution cost must stay between 0 and 95%.":
      "El coste de distribución debe estar entre 0 y 95 %.",
    "Currency, variable cost and distribution cost must be complete together.":
      "Moneda, coste variable y coste de distribución deben informarse juntos.",
    "Choose hold or require approval for low confidence.":
      "Para baja confianza, elige mantener o exigir aprobación.",
    "An enabled near-gap policy must relax MinLOS and allow a positive capped discount.":
      "Una política de hueco cercano activa debe relajar la estancia mínima y permitir un descuento positivo limitado.",
    "An enabled near-gap policy requires complete economic evidence.":
      "Una política de hueco cercano activa exige evidencia económica completa.",
    "Enable the matching T07 orphan-gap policy first.":
      "Activa primero la política T07 correspondiente.",
    "A T07 one-night gap requires a one-night MinLOS floor.":
      "Un hueco T07 de una noche exige un mínimo de estancia de una noche.",
    "A disabled near-gap policy cannot relax MinLOS or retain a discount cap.":
      "Una política de hueco cercano desactivada no puede relajar la estancia mínima ni conservar un límite de descuento.",
    "The enabled strategy must resolve to one master-rate currency.":
      "La estrategia activa debe resolver una única moneda de tarifa maestra.",
    "Economic evidence currency must match the master room rate.":
      "La moneda de la evidencia económica debe coincidir con la tarifa maestra.",
    "Resolve the orphan-gap safeguard issues":
      "Resuelve las incidencias de las salvaguardas de huecos",
    "Response, horizon and near-gap safeguards are ready":
      "Las salvaguardas de respuesta, horizonte y huecos cercanos están listas",
    "Orphan-gap action": "Acción de hueco",
    Horizon: "Horizonte",
    "Certified gap": "Hueco certificado",
    nights: "noches",
    Certified: "Certificado",
    "Not certified": "No certificado",
    "No certified gap": "Sin hueco certificado",
    "Demand evidence": "Evidencia de demanda",
    "weak certified": "débil certificado",
    "not weak": "no débil",
    Low: "Baja",
    "MinLOS before → after": "Estancia mínima antes → después",
    "Price before → after": "Precio antes → después",
    "Requested → effective discount": "Descuento solicitado → efectivo",
    "Economic floor / variable cost": "Suelo económico / coste variable",
    Decision: "Decisión",
    "Unexpected automatic activation": "Activación automática inesperada",
    "Proposal only; not applied": "Solo propuesta; no aplicada",
    "0–7 days": "0–7 días",
    "8–21 days": "8–21 días",
    "22+ days": "22+ días",
    unavoidable: "inevitable",
    eliminable: "eliminable",
    indeterminate: "indeterminado",
    behind: "por detrás",
    "on pace": "en ritmo",
    ahead: "por delante",
    unchanged: "sin cambios",
    "relax and discount": "relajar y descontar",
    "discount capped": "descuento limitado",
    "relax restrictions": "relajar restricciones",
    "require approval": "exigir aprobación",
  },
  ca: {
    Save: "Desar",
    "Saving...": "Desant...",
    Cancel: "Cancel\u00b7lar",
    Close: "Tancar",
    Refresh: "Actualitzar",
    "Refreshing...": "Actualitzant...",
    Apply: "Aplicar",
    Clear: "Netejar",
    "Clear selection": "Esborrar selecci\u00f3",
    "Clear filters": "Esborrar filtres",
    "Add row": "Afegir fila",
    "Edit row": "Editar fila",
    Delete: "Eliminar",
    "Setup Integrity": "Integritat de configuraci\u00f3",
    "Check that the essential configuration is complete.":
      "Comprova que la configuraci\u00f3 essencial estigui completa.",
    "Guided setup": "Configuraci\u00f3 guiada",
    "Configure Revenue Optimizer in this order":
      "Configura l'Optimitzador d'ingressos en aquest ordre",
    "Complete the seven essential steps from left to right. The last two steps are optional refinements for hotels that need them.":
      "Completa els set passos essencials d'esquerra a dreta. Els dos darrers s\u00f3n ajustos opcionals per als hotels que els necessitin.",
    "Essential setup progress": "Progr\u00e9s de la configuraci\u00f3 essencial",
    "Essential setup": "Configuraci\u00f3 essencial",
    "Next recommended: {step}": "Seg\u00fcent recomanat: {step}",
    "The essential setup is complete.": "La configuraci\u00f3 essencial est\u00e0 completa.",
    "Setup steps": "Passos de configuraci\u00f3",
    Complete: "Completat",
    Optional: "Opcional",
    "Needs attention": "Requereix atenci\u00f3",
    Next: "Seg\u00fcent",
    "Current setup summary": "Resum de la configuraci\u00f3 actual",
    "Step {number} of {total}": "Pas {number} de {total}",
    Setup: "Configuraci\u00f3",
    "Complete when:": "Es considera completat quan:",
    "Previous: {step}": "Anterior: {step}",
    "Next: {step}": "Seg\u00fcent: {step}",
    "Continue to Signals & Forecast": "Continua a Senyals i previsi\u00f3",
    "Base pricing strategy": "Estrat\u00e8gia base de preus",
    "Define the hotel-wide objective, guardrails and planning horizon the optimizer should use first.":
      "Defineix l'objectiu general de l'hotel, els l\u00edmits de seguretat i l'horitz\u00f3 de planificaci\u00f3 que l'optimitzador ha d'utilitzar primer.",
    "Complete when one active whole-hotel strategy exists. Add category rules only for real exceptions.":
      "Es completa quan existeix una estrat\u00e8gia activa per a tot l'hotel. Afegeix regles per categoria nom\u00e9s per a excepcions reals.",
    "Market scope and competitors": "Abast de mercat i competidors",
    "Confirm which extracted hotels should influence the benchmark and how important each one is.":
      "Confirma quins hotels extrets han d'influir en el benchmark i quina import\u00e0ncia t\u00e9 cadascun.",
    "Complete when the extraction scope is available and at least one relevant competitor is active.":
      "Es completa quan l'abast d'extracci\u00f3 est\u00e0 disponible i hi ha almenys un competidor rellevant actiu.",
    "Comparable room mapping": "Correspond\u00e8ncia d'habitacions comparables",
    "Room mapping": "Correspond\u00e8ncia d'habitacions",
    "Match your room categories and competitor room names to comparable standard room types.":
      "Relaciona les teves categories d'habitaci\u00f3 i els noms d'habitacions dels competidors amb tipus d'habitaci\u00f3 est\u00e0ndard comparables.",
    "Complete when every active hotel room category has a valid standard-room mapping.":
      "Es completa quan totes les categories actives de l'hotel tenen una correspond\u00e8ncia v\u00e0lida amb una habitaci\u00f3 est\u00e0ndard.",
    "Season templates": "Plantilles de temporada",
    Seasons: "Temporades",
    "Create a small reusable set of demand seasons such as quiet, steady, busy and peak.":
      "Crea un petit conjunt reutilitzable de temporades de demanda, com ara tranquil\u00b7la, estable, alta i punta.",
    "Complete when at least one active season template is ready for calendar dates.":
      "Es completa quan hi ha almenys una plantilla de temporada activa preparada per assignar-la a dates.",
    "Season calendar": "Calendari de temporades",
    Calendar: "Calendari",
    "Place the season templates on real date ranges and resolve overlaps with clear priorities.":
      "Situa les plantilles de temporada en rangs de dates reals i resol els solapaments amb prioritats clares.",
    "Complete when the operating calendar has at least one active season period.":
      "Es completa quan el calendari operatiu t\u00e9 almenys un per\u00edode de temporada actiu.",
    "Quality calibration": "Calibratge de qualitat",
    Quality: "Qualitat",
    "Set the public review signal and the maximum influence quality may have on recommendations.":
      "Configura el senyal de ressenyes p\u00fabliques i la influ\u00e8ncia m\u00e0xima que la qualitat pot tenir en les recomanacions.",
    "Complete when the four quality calibration values have been reviewed and saved.":
      "Es completa quan s'han revisat i desat els quatre valors de calibratge de qualitat.",
    "Room and weekday refinements": "Ajustos per habitaci\u00f3 i dia de la setmana",
    Refinements: "Ajustos",
    "Optionally refine a season for room categories or weekdays that behave differently.":
      "Opcionalment, ajusta una temporada per a categories d'habitaci\u00f3 o dies de la setmana que es comportin de manera diferent.",
    "Optional. Add profiles only when a real category or weekday exception exists.":
      "Opcional. Afegeix perfils nom\u00e9s quan existeixi una excepci\u00f3 real per categoria o dia de la setmana.",
    "Temporary market disruptions": "Disrupcions temporals del mercat",
    Disruptions: "Disrupcions",
    "Optionally layer exceptional events or shocks on top of the normal season calendar.":
      "Opcionalment, superposa esdeveniments excepcionals o impactes al calendari normal de temporades.",
    "Optional. Use only for temporary situations that normal seasonality cannot explain.":
      "Opcional. Utilitza-ho nom\u00e9s per a situacions temporals que l'estacionalitat normal no pugui explicar.",
    "Whole-hotel strategy ready": "Estrat\u00e8gia per a tot l'hotel preparada",
    "Keep only one active whole-hotel strategy":
      "Mant\u00e9n nom\u00e9s una estrat\u00e8gia activa per a tot l'hotel",
    "Add one active whole-hotel strategy":
      "Afegeix una estrat\u00e8gia activa per a tot l'hotel",
    "Market extraction scope is not available yet":
      "L'abast d'extracci\u00f3 de mercat encara no est\u00e0 disponible",
    "Activate at least one relevant competitor": "Activa almenys un competidor rellevant",
    "{count} active competitor": "{count} competidor actiu",
    "{count} active competitors": "{count} competidors actius",
    "No hotel room categories found":
      "No s'han trobat categories d'habitaci\u00f3 de l'hotel",
    "{mapped}/{total} room categories mapped":
      "{mapped}/{total} categories d'habitaci\u00f3 relacionades",
    "Create the first active season template": "Crea la primera plantilla de temporada activa",
    "{count} active season template": "{count} plantilla de temporada activa",
    "{count} active season templates": "{count} plantilles de temporada actives",
    "Requires an active season template from step 5":
      "Requereix una plantilla de temporada activa del pas 5",
    "Place an active season on the calendar": "Situa una temporada activa al calendari",
    "{count} active calendar period": "{count} per\u00edode de calendari actiu",
    "{count} active calendar periods": "{count} per\u00edodes de calendari actius",
    "Quality calibration reviewed": "Calibratge de qualitat revisat",
    "Review and save the four quality values": "Revisa i desa els quatre valors de qualitat",
    "{count} active refinement": "{count} ajust actiu",
    "{count} active refinements": "{count} ajustos actius",
    "Optional \u2014 no refinements configured": "Opcional: no hi ha ajustos configurats",
    "{count} active disruption": "{count} disrupci\u00f3 activa",
    "{count} active disruptions": "{count} disrupcions actives",
    "Optional \u2014 no temporary disruptions": "Opcional: no hi ha disrupcions temporals",
    "Quality Settings": "Ajustos de qualitat",
    "Competitors": "Competidors",
    "Signals & Forecast": "Senyals i previsi\u00f3",
    "Market Benchmark": "Benchmark de mercat",
    "Recommendations Overview": "Resum de recomanacions",
    "Daily Recommendations": "Recomanacions di\u00e0ries",
    "Long-range Guidance": "Guia a llarg termini",
    "Room category": "Categoria d'habitaci\u00f3",
    "Stay date": "Data d'estada",
    "Current occ": "Ocupaci\u00f3 actual",
    "Final occ": "Ocupaci\u00f3 final",
    "On books": "En cartera",
    "Cancel pct": "% cancel\u00b7laci\u00f3",
    "Cancel rooms": "Habitacions cancel\u00b7lades",
    Pickup: "Pickup",
    "Net pickup": "Pickup net",
    "Market baseline": "Base de mercat",
    "Market sources": "Fonts de mercat",
    "Current price": "Preu actual",
    "Base price": "Preu base",
    Strategy: "Estrat\u00e8gia",
    "Forecast conf": "Conf. previsi\u00f3",
    Forecast: "Forecast",
    "Daily features": "Features di\u00e0ries",
    "Rows loaded": "Files carregades",
    "Avg current occupancy": "Ocupaci\u00f3 mitjana actual",
    "Avg final occupancy": "Ocupaci\u00f3 mitjana final",
    "Avg expected cancel pct": "% mitj\u00e0 previst de cancel\u00b7laci\u00f3",
    "Market signal rows": "Files amb senyal de mercat",
    "Stop sell rows": "Files amb stop sell",
    "All room categories": "Totes les categories",
    "Loading RMS signals...": "Carregant senyals RMS...",
    "No signal rows found for the selected filter.":
      "No s'han trobat files de senyals per al filtre seleccionat.",
    "Daily demand table by room category and stay date.":
      "Taula di\u00e0ria de demanda per categoria d'habitaci\u00f3 i data d'estada.",
    "This table shows only objective RMS inputs: demand, pickup, cancellations, market baseline and the active strategy context for each room category and stay date.":
      "Aquesta taula mostra nom\u00e9s inputs objectius del RMS: demanda, pickup, cancel\u00b7lacions, base de mercat i el context d'estrat\u00e8gia activa per a cada categoria i data d'estada.",
    "Could not load RMS meta.": "No s'ha pogut carregar la metainformaci\u00f3 RMS.",
    "Could not load RMS signals.": "No s'han pogut carregar els senyals RMS.",
    missing: "sense dades",
    Status: "Estat",
    "Date range": "Rang de dates",
    Started: "Iniciat",
    Finished: "Finalitzat",
    "Value: {value}": "Valor: {value}",
    "Current on-books category occupancy": "Ocupaci\u00f3 actual en cartera per categoria",
    "Main forward demand signal": "Principal senyal de demanda futura",
    "Cancellation pressure before arrival":
      "Pressi\u00f3 de cancel\u00b7laci\u00f3 abans de l'arribada",
    "Rows with comparable market prices": "Files amb preus comparables de mercat",
    "Rows blocked by no availability or stop sell":
      "Files bloquejades per manca de disponibilitat o stop sell",
    "Recommendations": "Recomanacions",
    "Long range": "Llarg termini",
    "Daily recommendation rows": "Files di\u00e0ries recomanades",
    "Avg recommended daily price": "Preu mitj\u00e0 diari recomanat",
    "Separate averages by currency; amounts are not combined.":
      "Mitjanes separades per moneda; els imports no es combinen.",
    "Average unavailable because currency could not be verified.":
      "Mitjana no disponible perqu\u00e8 no s'ha pogut verificar la moneda.",
    "Avg daily confidence": "Confian\u00e7a mitjana di\u00e0ria",
    "Rows pending review": "Files pendents de revisi\u00f3",
    "Approval & application workflow": "Workflow d'aprovaci\u00f3 i aplicaci\u00f3",
    "Approve, apply or roll back the complete certified run. Recommendation decisions remain immutable.":
      "Aprova, aplica o reverteix el run certificat complet. Les decisions de recomanaci\u00f3 continuen sent immutables.",
    "Loading recommendation workflow...": "Carregant el workflow de recomanacions...",
    "Operational actions are disabled because the workflow could not be verified.":
      "Les accions operatives estan deshabilitades perqu\u00e8 no s'ha pogut verificar el workflow.",
    "The workflow contract could not be verified. Actions are disabled.":
      "No s'ha pogut verificar el contracte del workflow. Les accions estan deshabilitades.",
    "Could not load the recommendation workflow.":
      "No s'ha pogut carregar el workflow de recomanacions.",
    "Latest operation": "\u00daltima operaci\u00f3",
    "Full-run operations only": "Nom\u00e9s operacions sobre el run complet",
    "Held-by-policy rows remain certified no-ops and are never forced into an application.":
      "Les files retingudes per pol\u00edtica continuen sent no-ops certificades i mai no es forcen en una aplicaci\u00f3.",
    "Approve run": "Aprovar run",
    "Apply approved run": "Aplicar run aprovat",
    "Rollback application": "Revertir aplicaci\u00f3",
    "Preparing preview...": "Preparant vista pr\u00e8via...",
    "You do not have permission to approve RMS runs.":
      "No tens perm\u00eds per aprovar runs RMS.",
    "You do not have permission to apply RMS runs.":
      "No tens perm\u00eds per aplicar runs RMS.",
    "You do not have permission to roll back RMS applications.":
      "No tens perm\u00eds per revertir aplicacions RMS.",
    "Recommendation decision": "Decisi\u00f3 de recomanaci\u00f3",
    "Operational workflow": "Workflow operatiu",
    "Approve recommendation run": "Aprovar run de recomanacions",
    "Apply approved recommendation run": "Aplicar run de recomanacions aprovat",
    "Rollback complete application": "Revertir l'aplicaci\u00f3 completa",
    "Approve full run": "Aprovar run complet",
    "Apply full run": "Aplicar run complet",
    "Rollback full application": "Revertir aplicaci\u00f3 completa",
    "This preview covers the complete recommendation run. Partial selection is not permitted.":
      "Aquesta vista pr\u00e8via cobreix el run complet de recomanacions. No es permet una selecci\u00f3 parcial.",
    Recommendation: "Recomanaci\u00f3",
    "And {count} more rows": "I {count} files m\u00e9s",
    "Audit note (optional)": "Nota d'auditoria (opcional)",
    "Add context for the audit trail": "Afegeix context per a la tra\u00e7a d'auditoria",
    "Preview expires at {time}": "La vista pr\u00e8via caduca a les {time}",
    "This operation is safely blocked": "Aquesta operaci\u00f3 est\u00e0 bloquejada de manera segura",
    "Unknown blocker": "Bloqueig desconegut",
    "The workflow preview could not be verified. Nothing was changed.":
      "No s'ha pogut verificar la vista pr\u00e8via del workflow. No s'ha canviat res.",
    "Could not preview this workflow action.":
      "No s'ha pogut previsualitzar aquesta acci\u00f3 del workflow.",
    "The preview expired. Generate a new preview.":
      "La vista pr\u00e8via ha caducat. Genera'n una de nova.",
    "Could not execute this workflow action.":
      "No s'ha pogut executar aquesta acci\u00f3 del workflow.",
    "The complete recommendation run was approved.":
      "S'ha aprovat el run complet de recomanacions.",
    "The complete run was applied in the PMS.":
      "El run complet s'ha aplicat al PMS.",
    "The complete application was rolled back in the PMS.":
      "L'aplicaci\u00f3 completa s'ha revertit al PMS.",
    pending_approval: "pendent d'aprovaci\u00f3",
    approved: "aprovat",
    rolled_back: "revertit",
    blocked: "bloquejat",
    queued: "en cua",
    processing: "processant",
    approval_required: "requereix aprovaci\u00f3",
    held_by_policy: "retingut per pol\u00edtica",
    applied_local: "aplicat localment",
    rollback_blocked: "reversi\u00f3 bloquejada",
    "Total rows": "Files totals",
    "Actionable rows": "Files accionables",
    "Executable rows": "Files executables",
    "Pending rows": "Files pendents",
    "Approval-required rows": "Files que requereixen aprovaci\u00f3",
    "Held-by-policy rows": "Files retingudes per pol\u00edtica",
    "Certified no-op rows": "Files no-op certificades",
    "Changed rows": "Files modificades",
    "Applied rows": "Files aplicades",
    "Rollback rows": "Files a revertir",
    "Price rows": "Files de preu",
    "Length-of-stay rows": "Files d'estada m\u00ednima/m\u00e0xima",
    "The workflow execution response could not be verified. Refresh its status.":
      "No s'ha pogut verificar la resposta d'execuci\u00f3 del workflow. Actualitza'n l'estat.",
    "The pipeline is no longer current. Refresh and review the new run.":
      "El pipeline ja no \u00e9s l'actual. Actualitza i revisa el nou run.",
    "The approval is stale. Generate a new preview and approve the run again.":
      "L'aprovaci\u00f3 est\u00e0 desactualitzada. Genera una nova vista pr\u00e8via i torna a aprovar el run.",
    "This action is no longer valid for the current workflow state.":
      "Aquesta acci\u00f3 ja no \u00e9s v\u00e0lida per a l'estat actual del workflow.",
    "The workflow changed while you were reviewing it. Refresh before continuing.":
      "El workflow ha canviat mentre el revisaves. Actualitza abans de continuar.",
    "The execution plan changed. Generate a new preview before continuing.":
      "El pla d'execuci\u00f3 ha canviat. Genera una nova vista pr\u00e8via abans de continuar.",
    "One or more live prices changed. Review a fresh preview before continuing.":
      "Un o m\u00e9s preus actius han canviat. Revisa una nova vista pr\u00e8via abans de continuar.",
    "The live rate state has changed since application. Rollback was safely blocked.":
      "L'estat actiu de tarifes ha canviat des de l'aplicaci\u00f3. La reversi\u00f3 s'ha bloquejat de manera segura.",
    "There are no executable changes in this recommendation run.":
      "No hi ha canvis executables en aquest run de recomanacions.",
    "Only a complete recommendation run using contract v6 can be operated.":
      "Nom\u00e9s es pot operar un run complet de recomanacions amb contracte v6.",
    "The recommendation lineage could not be verified. The run cannot be operated.":
      "No s'ha pogut verificar la tra\u00e7abilitat de les recomanacions. El run no es pot operar.",
    "At least one rate product is not safe to execute.":
      "Almenys un producte de tarifa no \u00e9s segur per executar.",
    "At least one proposed change is protected by an active stop-sell.":
      "Almenys un canvi proposat est\u00e0 protegit per un stop-sell actiu.",
    "This operation key was already used with different data. Refresh before retrying.":
      "Aquesta clau d'operaci\u00f3 ja s'ha utilitzat amb dades diferents. Actualitza abans de reintentar.",
    "Long-range rows": "Files de llarg termini",
    "Avg long-range price": "Preu mitj\u00e0 a llarg termini",
    "Market signal coverage": "Cobertura del senyal de mercat",
    "Stop-sell rows": "Files amb stop sell",
    "Daily window": "Finestra di\u00e0ria",
    "Long-range window": "Finestra de llarg termini",
    "Loading daily recommendations...": "Carregant recomanacions di\u00e0ries...",
    "No daily recommendations found for the selected filter.":
      "No s'han trobat recomanacions di\u00e0ries per al filtre seleccionat.",
    "Loading long-range guidance...": "Carregant guia a llarg termini...",
    "No long-range guidance rows found for the selected filter.":
      "No s'han trobat files de guia a llarg termini per al filtre seleccionat.",
    "Recommended price": "Preu recomanat",
    "Origin & AI": "Origen i IA",
    "How to read Origin & AI": "Com interpretar Origen i IA",
    "AI-assisted explanation": "Explicació assistida per IA",
    "AI explains the recommendation; price and stay rules remain deterministic.":
      "La IA explica la recomanació; el preu i les regles d'estada continuen sent deterministes.",
    "Validated AI number": "Valor numèric d'IA validat",
    "The AI number passed deterministic limits and post-validation.":
      "El valor numèric de la IA ha superat els límits i la postvalidació deterministes.",
    "Deterministic engine": "Motor determinista",
    "Price and stay rules were calculated by the deterministic engine.":
      "El preu i les regles d'estada han estat calculats pel motor determinista.",
    "Deterministic fallback": "Fallback determinista",
    "The AI result was not used and the deterministic result was kept.":
      "No s'ha utilitzat el resultat de la IA i s'ha conservat el resultat determinista.",
    "Origin not verified": "Origen no verificat",
    "This historical row has no verifiable recommendation origin.":
      "Aquesta fila històrica no té un origen de recomanació verificable.",
    "AI rejected; deterministic result used.":
      "IA rebutjada; s'ha utilitzat el resultat determinista.",
    "AI result not used; deterministic result used.":
      "No s'ha utilitzat el resultat de la IA; s'ha utilitzat el resultat determinista.",
    "AI validation: {status}": "Validació d'IA: {status}",
    "Not requested": "No sol·licitada",
    Accepted: "Acceptada",
    Rejected: "Rebutjada",
    Unavailable: "No disponible",
    "Batch error": "Error de lot",
    "Missing row": "Fila absent",
    "Rejection codes: {codes}": "Codis de rebuig: {codes}",
    "Rejection details are unavailable.":
      "Els detalls del rebuig no estan disponibles.",
    "AI anomaly codes: {codes}": "Codis d'anomalia d'IA: {codes}",
    "AI trace: {model} · {prompt}": "Traça d'IA: {model} · {prompt}",
    "AI hashes: request {request} · response {response}":
      "Empremtes d'IA: sol·licitud {request} · resposta {response}",
    "Source metadata could not be verified.":
      "No s'han pogut verificar les metadades d'origen.",
    "AI-assisted explanation never changes price or stay rules. Only Validated AI number means an AI numeric proposal passed deterministic validation.":
      "L'explicació assistida per IA mai no canvia el preu ni les regles d'estada. Només Valor numèric d'IA validat indica que una proposta numèrica de la IA ha superat la validació determinista.",
    "Pipeline not verified": "Pipeline no verificat",
    "Coherent pipeline": "Pipeline coherent",
    "Stale pipeline": "Pipeline desactualitzat",
    "Checking pipeline...": "Verificant pipeline...",
    "Verifying that every section uses one published snapshot.":
      "Comprovant que totes les seccions utilitzen una única captura publicada.",
    "Pipeline #{id}": "Pipeline #{id}",
    "Published {date}": "Publicat {date}",
    "Status: {status}": "Estat: {status}",
    "Stages {completed}/{expected}": "Etapes {completed}/{expected}",
    "This response cannot prove that all RMS sections come from one published snapshot.":
      "Aquesta resposta no pot demostrar que totes les seccions de l'RMS procedeixin d'una única captura publicada.",
    "Latest attempt #{id}: {status}": "Últim intent #{id}: {status}",
    "Latest attempt error: {message}": "Error de l'últim intent: {message}",
    "{count} more pipeline issues": "{count} incidències més del pipeline",
    "All visible RMS sections belong to this published pipeline.":
      "Totes les seccions visibles de l'RMS pertanyen a aquest pipeline publicat.",
    "Cancellation curves": "Corbes de cancel·lació",
    "Demand forecast": "Previsió de demanda",
    "Long-range guidance": "Guia de llarg termini",
    "Daily signals": "Senyals diaris",
    "Signal and forecast rows": "Files de senyals i previsió",
    "Recommendation run": "Execució de recomanacions",
    "Recommendation rows": "Files de recomanacions",
    "Long-range run": "Execució de llarg termini",
    "Pinned snapshot": "Captura fixada",
    "Snapshot data is hidden because pipeline identity could not be verified.":
      "Les dades de la captura estan ocultes perquè no s'ha pogut verificar la identitat del pipeline.",
    "the pipeline": "el pipeline",
    "No published pipeline is available.": "No hi ha cap pipeline publicat disponible.",
    "The pipeline has not been published.": "El pipeline no s'ha publicat.",
    "The pipeline has not completed every required stage.":
      "El pipeline no ha completat totes les etapes obligatòries.",
    "The {stage} stage has no run linked to this pipeline.":
      "L'etapa {stage} no té cap execució vinculada a aquest pipeline.",
    "The {stage} stage run falls outside this pipeline's execution window.":
      "L'execució de l'etapa {stage} queda fora de la finestra d'execució d'aquest pipeline.",
    "The {stage} stage run uses a different date range from this pipeline.":
      "L'execució de l'etapa {stage} utilitza un interval de dates diferent del d'aquest pipeline.",
    "A newer pipeline is still running.": "Hi ha un pipeline més recent encara en execució.",
    "A newer pipeline attempt failed.": "Ha fallat un intent de pipeline més recent.",
    "{section} contains legacy data without a pipeline ID.":
      "{section} conté dades heretades sense ID de pipeline.",
    "The requested run does not belong to the published pipeline.":
      "L'execució sol·licitada no pertany al pipeline publicat.",
    "The requested run could not be found.": "No s'ha trobat l'execució sol·licitada.",
    "The pipeline is still running.": "El pipeline encara està en execució.",
    "The pipeline finished with an error.": "El pipeline ha finalitzat amb un error.",
    "The published pipeline is no longer current.":
      "El pipeline publicat ja no és el vigent.",
    "The pipeline was marked stale without further detail.":
      "El pipeline s'ha marcat com a desactualitzat sense més detalls.",
    "{section} belongs to a different pipeline.":
      "{section} pertany a un pipeline diferent.",
    "{section} contains data from a different pipeline.":
      "{section} conté dades d'un pipeline diferent.",
    "{section} is marked stale.": "{section} està marcada com a desactualitzada.",
    "Pipeline metadata is missing or invalid.":
      "Falten les metadades del pipeline o no són vàlides.",
    "Pipeline reported: {reason}": "Incidència comunicada pel pipeline: {reason}",
    "Delta vs current": "Delta vs actual",
    "Min stay": "Estada m\u00ednima",
    "Max stay": "Estada m\u00e0xima",
    Confidence: "Confian\u00e7a",
    "Apply status": "Estat d'aplicaci\u00f3",
    Reason: "Motiu",
    "Block type": "Tipus de bloc",
    "Seasonality template": "Plantilla d'estacionalitat",
    "Block #{id}": "Bloc #{id}",
    "Sources: {count}": "Fonts: {count}",
    Yes: "S\u00ed",
    No: "No",
    pending: "pendent",
    active: "actiu",
    inactive: "inactiu",
    running: "executant-se",
    warning: "av\u00eds",
    ok: "ok",
    error: "error",
    "Here you can review the final daily recommendations and the longer-term guidance proposed by the optimizer before taking any pricing decision.":
      "Aqu\u00ed pots revisar les recomanacions di\u00e0ries finals i la guia a m\u00e9s llarg termini proposada per l'optimitzador abans de prendre cap decisi\u00f3 de pricing.",
    "Final optimizer output for near-term dates and longer-term guidance.":
      "Sortida final de l'optimitzador per a dates properes i guia a m\u00e9s llarg termini.",
    "Could not load RMS recommendations.":
      "No s'han pogut carregar les recomanacions RMS.",
    "Could not load RMS long-range guidance.":
      "No s'ha pogut carregar la guia RMS a llarg termini.",
    "Latest successful recommendations run": "\u00daltima execuci\u00f3 correcta de recomanacions",
    "{count} blocks generated": "{count} blocs generats",
    "Model confidence for detailed horizon pricing":
      "Confian\u00e7a del model per al pricing de l'horitz\u00f3 detallat",
    "Recommendations not yet reviewed or used operationally":
      "Recomanacions encara no revisades ni usades operativament",
    "Average block guidance beyond detailed horizon":
      "Mitjana de guia per blocs m\u00e9s enll\u00e0 de l'horitz\u00f3 detallat",
    "Rows already protected by stop-sell":
      "Files ja protegides per stop sell",
    "{count} daily rows with comparable benchmark":
      "{count} files di\u00e0ries amb benchmark comparable",
    "Detailed horizon from {from} to {to}.":
      "Horitz\u00f3 detallat des de {from} fins a {to}.",
    "Guidance blocks from {from} to {to}.":
      "Blocs de guia des de {from} fins a {to}.",
    "Loading competitor prices...": "Carregant preus de competidors...",
    "No competitor prices match the current filters.":
      "Cap preu de competidor coincideix amb els filtres actuals.",
    "Competitor room": "Habitaci\u00f3 competidor",
    "Standard type": "Tipus est\u00e0ndard",
    "My room categories": "Les meves categories",
    Competitor: "Competidor",
    "Competitor hotel": "Hotel competidor",
    Weight: "Pes",
    mapped: "mapejades",
    "Meal plans": "Plans d'\u00e0pats",
    "Rate conditions": "Condicions tarif\u00e0ries",
    "(none)": "(cap)",
    Standard: "Est\u00e0ndard",
    Unmapped: "Sense mapatge",
    "Not mapped yet": "Encara sense mapatge",
    "No own room category linked yet": "Encara no hi ha cap categoria pr\u00f2pia vinculada",
    "Price shown": "Preu mostrat",
    "Price / night": "Preu / nit",
    "Estimated / night": "Estimat / nit",
    "Observed / night": "Observat / nit",
    "Verified with 1-night prices": "Verificat amb preus d'1 nit",
    "Estimate from the average nightly prices of 2-night stays that include this date.":
      "Estimació a partir de les mitjanes per nit de les estades de 2 nits que inclouen aquesta data.",
    "Nightly price verified using 1-night quotes and a matching 2-night stay.":
      "Preu per nit verificat amb preus d'1 nit i una estada de 2 nits amb un total coincident.",
    "{count} stays used": "{count} estades utilitzades",
    "Average nightly price range": "Rang de les mitjanes per nit",
    "Source stay": "Estada consultada",
    "Source stay total": "Total de l'estada consultada",
    "Source stay average / night": "Mitjana per nit de l'estada consultada",
    "Stay length": "Durada de l'estada",
    "All stay lengths": "Totes les durades",
    "1 night": "1 nit",
    "2 nights": "2 nits",
    Promotion: "Promoció",
    Payment: "Pagament",
    Taxes: "Impostos",
    "Select an offer. Prices are shown per night; estimates are marked and explained in the price detail.":
      "Selecciona una oferta. Els preus es mostren per nit; els estimats s'identifiquen i s'expliquen al detall del preu.",
    "Meal plan": "Pla d'\u00e0pats",
    "Click to open source": "Fes clic per obrir la font",
    "pax not set": "pax sense definir",
    "pax n/a": "pax n/d",
    "LOS n/a": "LOS n/d",
    "All competitors": "Tots els competidors",
    "Search options...": "Cercar opcions...",
    "No options match this search.": "Cap opci\u00f3 coincideix amb aquesta cerca.",
    "Showing {from} to {to}": "Mostrant de {from} a {to}",
    "Could not load market benchmark.":
      "No s'ha pogut carregar el benchmark de mercat.",
    "Competitor prices grouped by hotel and competitor room type.":
      "Preus de competidors agrupats per hotel i tipus d'habitaci\u00f3 del competidor.",
    "Room types": "Tipus d'habitaci\u00f3",
    "Mapped lines": "L\u00ednies mapejades",
    "Latest snapshot": "\u00daltima captura",
    "Hotels visible with the current filters":
      "Hotels visibles amb els filtres actuals",
    "Competitor room lines in this date range":
      "L\u00ednies d'habitacions competidores en aquest rang",
    "Room lines already linked to an RMS standard type":
      "L\u00ednies ja vinculades a un tipus est\u00e0ndard RMS",
    "Most recent market extraction shown here":
      "Extracci\u00f3 de mercat m\u00e9s recent mostrada aqu\u00ed",
    "Choose which meal plans should stay visible in the benchmark.":
      "Tria quins plans d'\u00e0pats han de continuar visibles al benchmark.",
    "Choose which rate plans or cancellation conditions should stay visible.":
      "Tria quines tarifes o condicions de cancel\u00b7laci\u00f3 han de continuar visibles.",
    "Market pricing workspace": "Espai de preus de mercat",
    "Observed prices": "Preus observats",
    "See raw competitor offers": "Consulta ofertes directes de competidors",
    "Create reference": "Crear refer\u00e8ncia",
    "Saved references": "Refer\u00e8ncies desades",
    "Review or apply later": "Revisar o aplicar m\u00e9s endavant",
    "Select exact offers": "Selecciona ofertes exactes",
    "{count} offers selected": "{count} ofertes seleccionades",
    "Raw competitor prices. Each row is one exact source, room, occupancy, LOS, meal plan and rate condition.":
      "Preus directes de la compet\u00e8ncia. Cada fila representa una font, habitaci\u00f3, ocupaci\u00f3, LOS, pla d'\u00e0pats i condici\u00f3 tarif\u00e0ria exactes.",
    "Exact offers": "Ofertes exactes",
    "Separate source, room, occupancy, LOS and rate conditions":
      "Font, habitaci\u00f3, ocupaci\u00f3, LOS i condicions separats",
    "Mapped offers": "Ofertes mapejades",
    "Offers already linked to an RMS standard type":
      "Ofertes ja vinculades a un tipus est\u00e0ndard RMS",
    "Select the exact competitor offers you want to use":
      "Selecciona les ofertes exactes dels competidors que vols utilitzar",
    "Use the checkbox beside a room offer. Nothing is averaged or transformed on this screen.":
      "Utilitza la casella al costat de cada oferta. En aquesta pantalla no es fa cap mitjana ni transformaci\u00f3.",
    "{count} exact offers selected": "{count} ofertes exactes seleccionades",
    "These offers will be preserved individually in the market reference.":
      "Aquestes ofertes es conservaran individualment a la refer\u00e8ncia de mercat.",
    "Create reference with selection": "Crear refer\u00e8ncia amb la selecci\u00f3",
    "Competitor offer": "Oferta del competidor",
    "{count} exact offers": "{count} ofertes exactes",
    "Unknown source": "Font desconeguda",
    "No meal plan": "Sense pla d'\u00e0pats",
    "No rate conditions": "Sense condicions tarif\u00e0ries",
    "Create a market price reference": "Crear una refer\u00e8ncia de preus de mercat",
    "Choose exact competitor offers, combine them and decide how your own rate should be positioned.":
      "Tria ofertes exactes de competidors, combina-les i decideix com s'ha de posicionar la teva tarifa.",
    "Manual mode": "Mode manual",
    "Competitor offers": "Ofertes de competidors",
    "Only the exact offers selected in Observed prices are used.":
      "Nom\u00e9s s'utilitzen les ofertes exactes seleccionades a Preus observats.",
    "Go to Observed prices and select at least one competitor offer.":
      "Ves a Preus observats i selecciona almenys una oferta de competidor.",
    "Remove {name}": "Treure {name}",
    "Destination and dates": "Destinaci\u00f3 i dates",
    "Choose the base room rate whose prices may be changed.":
      "Tria la tarifa base els preus de la qual es podran modificar.",
    "Reference name": "Nom de la refer\u00e8ncia",
    "Example: Flexible BAR vs direct competitors":
      "Exemple: BAR flexible davant de competidors directes",
    "Destination room rate": "Tarifa d'habitaci\u00f3 de destinaci\u00f3",
    "No base room rates available": "No hi ha tarifes base disponibles",
    From: "Des de",
    To: "Fins a",
    Currency: "Moneda",
    "Allowed range": "Rang perm\u00e8s",
    Calculation: "C\u00e0lcul",
    "First combine the market prices, then place your own rate relative to that result.":
      "Primer combina els preus de mercat i despr\u00e9s posiciona la teva tarifa respecte del resultat.",
    "Combine competitor prices using": "Combinar preus de competidors mitjan\u00e7ant",
    Average: "Mitjana",
    Minimum: "M\u00ednim",
    Maximum: "M\u00e0xim",
    "Position my price": "Posicionar el meu preu",
    "Equal to the reference": "Igual a la refer\u00e8ncia",
    "Above the reference": "Per sobre de la refer\u00e8ncia",
    "Below the reference": "Per sota de la refer\u00e8ncia",
    "Adjustment type": "Tipus d'ajust",
    "Fixed amount": "Import fix",
    Percent: "Percentatge",
    "Adjustment value": "Valor de l'ajust",
    "Nothing changes until you press Save and apply.":
      "No canvia res fins que premis Desar i aplicar.",
    "Preview and Save reference are read-only for your room prices.":
      "Previsualitzar i Desar refer\u00e8ncia no modifiquen els preus de les habitacions.",
    "Preview result": "Previsualitzar resultat",
    "Calculating...": "Calculant...",
    "Preview before applying": "Previsualitzaci\u00f3 abans d'aplicar",
    "Ready to review": "A punt per revisar",
    "My current price": "El meu preu actual",
    "Combined reference": "Refer\u00e8ncia combinada",
    "Resulting price": "Preu resultant",
    Coverage: "Cobertura",
    Application: "Aplicaci\u00f3",
    "Market price comparison chart": "Gr\u00e0fic comparatiu de preus de mercat",
    "{method}, with no adjustment": "{method}, sense ajust",
    "{method}, {value}{suffix} {direction}": "{method}, {value}{suffix} {direction}",
    above: "per sobre",
    below: "per sota",
    "days with market price": "dies amb preu de mercat",
    "Review the curve and daily values before deciding.":
      "Revisa la corba i els valors diaris abans de decidir.",
    "Save keeps the snapshot for later. Save and apply writes the resulting prices now.":
      "Desar conserva la captura per a m\u00e9s endavant. Desar i aplicar escriu ara els preus resultants.",
    "Save reference": "Desar refer\u00e8ncia",
    "Reference saved": "Refer\u00e8ncia desada",
    "Save and apply prices": "Desar i aplicar preus",
    "Preparing application...": "Preparant aplicaci\u00f3...",
    "Applying {completed}/{total}...": "Aplicant {completed}/{total}...",
    "Select at least one exact competitor offer.":
      "Selecciona almenys una oferta exacta de competidor.",
    "Select a destination room rate.": "Selecciona una tarifa de destinaci\u00f3.",
    "Select a valid date range.": "Selecciona un rang de dates v\u00e0lid.",
    "Could not load destination room rates.":
      "No s'han pogut carregar les tarifes de destinaci\u00f3.",
    "Could not calculate the market reference.":
      "No s'ha pogut calcular la refer\u00e8ncia de mercat.",
    "You do not have permission to save or apply market prices.":
      "No tens perm\u00eds per desar o aplicar preus de mercat.",
    "Preview the result before saving it.":
      "Previsualitza el resultat abans de desar-lo.",
    "Could not save the market reference.":
      "No s'ha pogut desar la refer\u00e8ncia de mercat.",
    "The market reference was saved without changing prices.":
      "La refer\u00e8ncia de mercat s'ha desat sense modificar preus.",
    "The reference was saved and its prices were applied.":
      "La refer\u00e8ncia s'ha desat i els seus preus s'han aplicat.",
    "The reference was saved, but {count} dates could not be applied.":
      "La refer\u00e8ncia s'ha desat, per\u00f2 no s'han pogut aplicar {count} dates.",
    "Saved market references": "Refer\u00e8ncies de mercat desades",
    "Each reference preserves the competitor offers, calculation and daily snapshot used at that moment.":
      "Cada refer\u00e8ncia conserva les ofertes de competidors, el c\u00e0lcul i la captura di\u00e0ria utilitzats en aquell moment.",
    Reference: "Refer\u00e8ncia",
    "Loading saved market references...": "Carregant refer\u00e8ncies de mercat desades...",
    "No market references have been saved yet.":
      "Encara no s'ha desat cap refer\u00e8ncia de mercat.",
    "Loading reference detail...": "Carregant el detall de la refer\u00e8ncia...",
    "Could not load saved market references.":
      "No s'han pogut carregar les refer\u00e8ncies de mercat desades.",
    "Could not load this market reference.":
      "No s'ha pogut carregar aquesta refer\u00e8ncia de mercat.",
    "Apply saved prices": "Aplicar preus desats",
    "Retry pending prices": "Reintentar preus pendents",
    "All pending prices in this reference were applied.":
      "S'han aplicat tots els preus pendents d'aquesta refer\u00e8ncia.",
    "The reference remains partially applied: {count} dates failed.":
      "La refer\u00e8ncia continua aplicada parcialment: han fallat {count} dates.",
    "Could not apply this market reference.":
      "No s'ha pogut aplicar aquesta refer\u00e8ncia de mercat.",
    draft: "esborrany",
    applied: "aplicada",
    partially_applied: "aplicada parcialment",
    unavailable: "sense preu",
    failed: "fallida",
    "Not mapped": "Sense mapatge",
    "Not linked yet": "Encara sense vincle",
    Closed: "Tancat",
    "Market Mapping Board": "Panell de mapatge de mercat",
    "Match your room categories and competitor room types to the shared standard market types.":
      "Relaciona les teves categories d'habitaci\u00f3 i els tipus d'habitaci\u00f3 dels competidors amb els tipus est\u00e0ndard compartits del mercat.",
    "Loading mapping studio...": "Carregant estudi de mapatge...",
    "No standard market types are available yet.":
      "Encara no hi ha tipus de mercat est\u00e0ndard disponibles.",
    "Your hotel": "El teu hotel",
    "Shared market types": "Tipus de mercat compartits",
    "Standard room types": "Tipus d'habitaci\u00f3 est\u00e0ndard",
    "{count} pax view": "Vista per a {count} pax",
    "Choose a standard row for the selected room, or drag it there.":
      "Tria una fila est\u00e0ndard per a l'habitaci\u00f3 seleccionada o arrossega-la fins all\u00e0.",
    "Drag an unassigned room into its comparable standard row.":
      "Arrossega una habitaci\u00f3 sense assignar fins a la seva fila est\u00e0ndard comparable.",
    "Own mapped": "Habitacions pr\u00f2pies assignades",
    "Competitor mapped": "Habitacions competidores assignades",
    "Each row is one comparable market family.":
      "Cada fila representa una fam\u00edlia de mercat comparable.",
    "Drop a room here to start mapping.":
      "Arrossega una habitaci\u00f3 aqu\u00ed per comen\u00e7ar a assignar-la.",
    "Selected room details": "Detalls de l'habitaci\u00f3 seleccionada",
    "Showing now": "Mostrant ara",
    Own: "Propi",
    Competition: "Compet\u00e8ncia",
    "Competitor room types": "Tipus d'habitaci\u00f3 dels competidors",
    "Click any small card to see its details here.":
      "Fes clic a qualsevol targeta petita per veure'n aqu\u00ed els detalls.",
    "Own room category": "Categoria pr\u00f2pia",
    "Competitor room type": "Tipus d'habitaci\u00f3 competidor",
    "Current standard type": "Tipus est\u00e0ndard actual",
    "Not assigned yet": "Encara no assignat",
    "Comparable guests": "Hostes comparables",
    "Standard default": "Valor est\u00e0ndard",
    "Pick a standard type first": "Primer tria un tipus est\u00e0ndard",
    "Save guests": "Desar hostes",
    "Send to unassigned": "Enviar a no assignats",
    "Market options found": "Opcions de mercat trobades",
    "Normalized name": "Nom normalitzat",
    "No guest options found yet": "Encara no s'han trobat opcions d'hostes",
    "Pick pax": "Triar pax",
    "You do not have permission to edit this setup.":
      "No tens perm\u00eds per editar aquesta configuraci\u00f3.",
    "Define how the optimizer should understand your hotel, your room categories, your comparable market and your demand context.":
      "Defineix com ha d'entendre l'optimitzador el teu hotel, les teves categories, el teu mercat comparable i el teu context de demanda.",
    "Tell the RMS how strong your hotel quality signal is when compared with the market.":
      "Indica al RMS com de fort és el senyal de qualitat del teu hotel respecte del mercat.",
    "Save quality settings": "Desar ajustos de qualitat",
    "These values do not set prices directly. They only tell the RMS how much hotel quality should matter when it compares your hotel with competitors.":
      "Aquests valors no fixen preus directament. Només indiquen al RMS quant ha de pesar la qualitat de l'hotel quan et compara amb els competidors.",
    "Current public review score": "Puntuaci\u00f3 p\u00fablica actual",
    "Number of reviews": "Nombre de ressenyes",
    "Price impact for 1 review point": "Impacte en preu per 1 punt de ressenya",
    "Maximum quality impact": "Impacte m\u00e0xim de qualitat",
    pax: "pax",
    adult: "adult",
    adults: "adults",
    child: "nen",
    children: "nens",
    total: "total",
    "Could not load competitor room types.":
      "No s'han pogut carregar els tipus d'habitaci\u00f3 dels competidors.",
    "Comparable guests for {name} must be greater than 0.":
      "Els hostes comparables per a {name} han de ser majors que 0.",
    "{name} only has market rows for {options}.":
      "{name} nom\u00e9s t\u00e9 files de mercat per a {options}.",
    "No category assigned": "Cap categoria assignada",
    "No competitor type assigned": "Cap tipus de competidor assignat",
    "Review which hotels are in your market scope and decide how strongly each one should influence the RMS.":
      "Revisa quins hotels s\u00f3n dins del teu abast de mercat i decideix quant han d'influir en el RMS.",
    "Loading competitors...": "Carregant competidors...",
    "No competitor hotels are available yet in the market extraction scope.":
      "Encara no hi ha hotels competidors disponibles dins l'abast d'extracci\u00f3 del mercat.",
    "Adjust competitor": "Ajustar competidor",
    "Room categories mapped": "Categories mapejades",
    "still without mapping": "encara sense mapatge",
    "No categories found": "No s'han trobat categories",
    "Active strategies": "Estrat\u00e8gies actives",
    "Hotel-level and category-level posture":
      "Postura a nivell d'hotel i de categoria",
    "Active competitors": "Competidors actius",
    "currently ignored": "ignorats actualment",
    "No competitor scope configured": "No hi ha abast de competidors configurat",
    "active disruptions": "disrupcions actives",
    Actions: "Accions",
    "Advanced edit": "Edici\u00f3 avançada",
    "Delete row #{id} from {title}?": "Vols eliminar la fila #{id} de {title}?",
    "Standard Room Types": "Tipus d'habitaci\u00f3 est\u00e0ndard",
    "Comparable types used only for market matching.":
      "Tipus comparables usats nom\u00e9s per a l'emparellament de mercat.",
    "Room Category Mappings": "Mapatges de categories",
    "Internal category to standard type mapping for market comparison.":
      "Mapatge de categoria interna a tipus est\u00e0ndard per a comparaci\u00f3 de mercat.",
    "Strategy Settings": "Ajustos d'estrat\u00e8gia",
    "Hotel or room-category strategy rules.":
      "Regles d'estrat\u00e8gia a nivell d'hotel o categoria.",
    "Competitor Room Type Mappings": "Mapatges de tipus d'habitaci\u00f3 competidor",
    "Normalization of competitor room names into standard types and comparable guests.":
      "Normalitzaci\u00f3 de noms d'habitacions de competidors a tipus est\u00e0ndard i hostes comparables.",
    "Seasonality Templates": "Plantilles d'estacionalitat",
    "Reusable demand templates.": "Plantilles reutilitzables de demanda.",
    "Seasonality Periods": "Per\u00edodes d'estacionalitat",
    "Date ranges assigned to one template.": "Rangs de dates assignats a una plantilla.",
    "Seasonality Profiles": "Perfils d'estacionalitat",
    "Expected demand or pricing behavior by room category and day of week.":
      "Demanda esperada o comportament de pricing per categoria i dia de la setmana.",
    "Market Disruptions": "Disrupcions de mercat",
    "Short-term shocks that should make the RMS firmer or softer than normal.":
      "Impactes de curt termini que han de fer el RMS m\u00e9s ferm o m\u00e9s suau del normal.",
    "Add strategy": "Afegir estrat\u00e8gia",
    "Edit strategy": "Editar estrat\u00e8gia",
    "Edit template": "Editar plantilla",
    "Edit period": "Editar per\u00edode",
    "Edit profile": "Editar perfil",
    "Edit disruption": "Editar disrupci\u00f3",
    "Could not save RMS quality settings.":
      "No s'han pogut desar els ajustos de qualitat RMS.",
    "Could not save competitor settings.":
      "No s'han pogut desar els ajustos del competidor.",
    "Could not save RMS resource.": "No s'ha pogut desar el recurs RMS.",
    "Could not delete RMS resource.": "No s'ha pogut eliminar el recurs RMS.",
    Occupancy: "Ocupació",
    LOS: "LOS",
    "Code {code}": "Codi {code}",
    "{count} room types": "{count} tipus d'habitació",
    "{count} mapped": "{count} mapejats",
    "You are classifying {count} pax now. Only cards that belong to {count} pax are shown in the middle, and the selected card can be dropped into one of the standard boxes.":
      "Ara estàs classificant {count} pax. Només es mostren al centre les targetes que pertanyen a {count} pax, i la targeta seleccionada es pot deixar dins d'una de les caixes estàndard.",
    "You are classifying {count} pax now. Only cards that belong to {count} pax are shown in the middle. Drag a small card into one of the standard boxes in the middle.":
      "Ara estàs classificant {count} pax. Només es mostren al centre les targetes que pertanyen a {count} pax. Arrossega una targeta petita cap a una de les caixes estàndard del centre.",
    "Cards only appear here when they can be classified for the pax you are viewing now.":
      "Les targetes només apareixen aquí quan es poden classificar per als pax que estàs veient ara.",
    "category available": "categoria disponible",
    "categories available": "categories disponibles",
    "type available": "tipus disponible",
    "types available": "tipus disponibles",
    "No room category is waiting to be classified for {count} pax.":
      "No hi ha cap categoria d'habitació pendent de classificar per a {count} pax.",
    "The middle box defines the market family. The selector here changes the active pax view used to classify cards.":
      "La caixa central defineix la família de mercat. El selector canvia la vista activa de pax utilitzada per classificar targetes.",
    "No competitor room type is waiting to be classified for {count} pax.":
      "No hi ha cap tipus d'habitació competidora pendent de classificar per a {count} pax.",
    days: "dies",
    nights: "nits",
    index: "índex",
    "Template default": "Valor per defecte de la plantilla",
    "Full confidence": "Confiança total",
    "Choose a season": "Tria una temporada",
    "Priority {value}": "Prioritat {value}",
    "Choose a room category": "Tria una categoria d'habitació",
    "Custom demand tone": "To de demanda personalitzat",
    "Demand tone": "To de demanda",
    "Template demand tone": "To de demanda de la plantilla",
    "Choose a disruption type": "Tria un tipus de disrupció",
    "Choose direction": "Tria una direcció",
    "Choose strength": "Tria una intensitat",
    "This period runs from {from} to {to}.":
      "Aquest període va de {from} a {to}.",
    "Loading {title}...": "Carregant {title}...",
    "No rows yet for {title}.": "Encara no hi ha files per a {title}.",
    "This list is controlled by your market data extraction scope. It is read-only here, so this screen does not add or remove competitor hotels.":
      "Aquesta llista la controla l'abast d'extracció de dades de mercat. Aquí és només de lectura, de manera que aquesta pantalla no afegeix ni elimina hotels competidors.",
    "What you can control here is how much each competitor matters in the RMS benchmark, and whether a competitor should influence the optimizer right now.":
      "Aquí pots controlar quant pesa cada competidor dins del benchmark RMS i si ha d'influir en l'optimitzador ara mateix.",
    "Extraction scope": "Abast d'extracció",
    "Not configured yet": "Encara no configurat",
    "Currency: {currency}": "Moneda: {currency}",
    "No market scope has been loaded yet.":
      "Encara no s'ha carregat cap abast de mercat.",
    Sources: "Fonts",
    "No sources detected": "No s'han detectat fonts",
    "{count} source feeding this benchmark": "{count} font alimenta aquest benchmark",
    "{count} sources feeding this benchmark": "{count} fonts alimenten aquest benchmark",
    "Sources are missing from the extraction scope.":
      "Falten fonts dins l'abast d'extracció.",
    "Competitors in scope": "Competidors dins l'abast",
    "{count} currently influence the RMS": "{count} influeixen actualment en el RMS",
    "Hotel code {code}": "Codi d'hotel {code}",
    "Influences RMS": "Influeix en el RMS",
    "Ignored by RMS": "Ignorat pel RMS",
    "Custom settings": "Ajustos personalitzats",
    "Default settings": "Ajustos per defecte",
    "Address stored in the extraction scope is not available.":
      "L'adreça desada dins l'abast d'extracció no està disponible.",
    Importance: "Importància",
    Distance: "Distància",
    "Public rating": "Valoració pública",
    Reviews: "Ressenyes",
    "Not set": "Sense definir",
    "This hotel currently contributes to your market benchmark.":
      "Aquest hotel contribueix actualment al teu benchmark de mercat.",
    "This hotel stays in the scope, but the RMS ignores it until you activate it again.":
      "Aquest hotel continua dins l'abast, però el RMS l'ignora fins que el tornis a activar.",
    "Decide how much this hotel should influence your market benchmark.":
      "Decideix quant ha d'influir aquest hotel en el teu benchmark de mercat.",
    "Competitor in extraction scope": "Competidor dins l'abast d'extracció",
    "Address not available": "Adreça no disponible",
    "1. How important should this competitor be?":
      "1. Quina importància ha de tenir aquest competidor?",
    "Use a bigger number when this hotel is one of your closest real references. Keep it smaller when it is only a secondary reference.":
      "Fes servir un número més gran quan aquest hotel sigui una de les teves referències reals més properes. Mantén-lo més petit quan només sigui una referència secundària.",
    "Importance in market benchmark": "Importància dins del benchmark de mercat",
    "Example: 1 means normal importance, 2 means this hotel counts about twice as much, and 0.5 means it counts about half as much.":
      "Exemple: 1 vol dir importància normal, 2 vol dir que aquest hotel compta aproximadament el doble i 0.5 vol dir que compta aproximadament la meitat.",
    "2. Optional reference details": "2. Detalls de referència opcionals",
    "These details help you review the competitor set with more context. Leave them empty if you do not need them.":
      "Aquests detalls t'ajuden a revisar el conjunt de competidors amb més context. Deixa'ls buits si no els necessites.",
    "Distance from your hotel": "Distància des del teu hotel",
    "Optional. A nearby hotel is often a stronger reference than one that is much farther away.":
      "Opcional. Un hotel proper sovint és una referència més forta que un de molt més llunyà.",
    "Public review score": "Puntuació pública de ressenyes",
    "Optional. This helps you remember whether the competitor is positioned above, below or close to your hotel in public perception.":
      "Opcional. Això t'ajuda a recordar si el competidor està per sobre, per sota o a prop del teu hotel en percepció pública.",
    "Optional. More reviews usually make that public rating more trustworthy.":
      "Opcional. Més ressenyes solen fer que aquesta valoració pública sigui més fiable.",
    "3. Should this competitor influence the RMS now?":
      "3. Ha d'influir aquest competidor en el RMS ara?",
    "Turn the competitor off when you want to keep it in scope but temporarily exclude it from the market benchmark.":
      "Desactiva el competidor quan vulguis mantenir-lo dins l'abast però excloure'l temporalment del benchmark de mercat.",
    "This competitor currently influences the RMS":
      "Aquest competidor influeix actualment en el RMS",
    "This competitor is currently ignored by the RMS":
      "Aquest competidor està actualment ignorat pel RMS",
    "Keep this on when the hotel is a valid benchmark reference.":
      "Mantén-ho activat quan l'hotel sigui una referència vàlida per al benchmark.",
    "Turn this back on when you want its prices to count again.":
      "Torna-ho a activar quan vulguis que els seus preus tornin a comptar.",
    "Whole hotel": "Hotel complet",
    "One room category": "Una categoria d'habitació",
    "Fill rooms": "Omplir habitacions",
    "Protect price": "Protegir preu",
    "Balanced": "Equilibrat",
    "Use season blocks": "Usar blocs de temporada",
    "Use calendar blocks": "Usar blocs de calendari",
    "Calendar ranges": "Rangs de calendari",
    "Quiet season": "Temporada tranquil·la",
    "Steady season": "Temporada estable",
    "Busy season": "Temporada activa",
    "Peak season": "Temporada punta",
    "Background season": "Temporada base",
    "Normal priority": "Prioritat normal",
    "Special override": "Override especial",
    "Every day": "Cada dia",
    Monday: "Dilluns",
    Tuesday: "Dimarts",
    Wednesday: "Dimecres",
    Thursday: "Dijous",
    Friday: "Divendres",
    Saturday: "Dissabte",
    Sunday: "Diumenge",
    "Local event": "Esdeveniment local",
    "Transport issue": "Incidència de transport",
    "Weather issue": "Incidència meteorològica",
    "Works nearby": "Obres properes",
    Restriction: "Restricció",
    "Market shock": "Xoc de mercat",
    Other: "Altre",
    "Push prices up": "Empènyer preus a l'alça",
    "Push prices down": "Empènyer preus a la baixa",
    "Low effect": "Efecte baix",
    "Medium effect": "Efecte mitjà",
    "High effect": "Efecte alt",
    "Severe effect": "Efecte sever",
    for: "per a",
    "This rule will only affect the selected room category.":
      "Aquesta regla només afectarà la categoria d'habitació seleccionada.",
    "This rule will affect every room category unless a more specific room-category rule exists.":
      "Aquesta regla afectarà totes les categories d'habitació tret que existeixi una regla més específica per categoria.",
    "Long-range blocks are currently set to {label}.":
      "Els blocs de llarg termini estan configurats actualment com a {label}.",
    "Reusable season template": "Plantilla de temporada reutilitzable",
    "Season name": "Nom de la temporada",
    "Short note": "Nota breu",
    "Custom label": "Etiqueta personalitzada",
    "Default price index": "Índex de preu per defecte",
    "Calendar season rule": "Regla de temporada de calendari",
    "Season template": "Plantilla de temporada",
    "Choose a season template": "Tria una plantilla de temporada",
    "Start date": "Data d'inici",
    "End date": "Data de fi",
    "Custom priority": "Prioritat personalitzada",
    "Priority number": "Número de prioritat",
    "Season refinement rule": "Regla de refinament de temporada",
    "Day of week": "Dia de la setmana",
    "Keep template demand tone": "Mantenir el to de demanda de la plantilla",
    "Price index override": "Override d'índex de preu",
    "Expected occupancy": "Ocupació esperada",
    "Temporary market shock": "Impacte temporal de mercat",
    "Disruption name": "Nom de la disrupció",
    "Confidence in this estimate": "Confiança en aquesta estimació",
    Source: "Font",
    Notes: "Notes",
    "What this rule is doing": "Què està fent aquesta regla",
    "Target occupancy": "Ocupació objectiu",
    "Minimum average daily rate": "Tarifa mitjana diària mínima",
    "Desired price position vs market": "Posició de preu desitjada respecte del mercat",
    "Lowest allowed price": "Preu mínim permès",
    "Highest allowed price": "Preu màxim permès",
    "Allow shorter minimum stays": "Permetre estades mínimes més curtes",
    "Allow longer minimum stays": "Permetre estades mínimes més llargues",
    "Shortest minimum stay allowed": "Estada mínima més curta permesa",
    "Longest minimum stay allowed": "Estada mínima més llarga permesa",
    "Daily recommendation horizon": "Horitzó diari de recomanació",
    "Shortest long-range period": "Període mínim de llarg termini",
    "Use this strategy now": "Usar aquesta estratègia ara",
    "Create strategy": "Crear estratègia",
    "Save strategy": "Desar estratègia",
    "Create row": "Crear fila",
    "Save changes": "Desar els canvis",
    "Save disruption": "Desar la disrupció",
    "Advanced configuration editor for this section.":
      "Editor de configuració avançada per a aquest apartat.",
    "Tell the optimizer where this rule applies, what it should prioritize and which limits it must respect.":
      "Indica a l'optimitzador on s'aplica aquesta regla, què ha de prioritzar i quins límits ha de respectar.",
    "{count}-day daily view": "Vista diària de {count} dies",
    "Active now": "Activa ara",
    "Saved as inactive": "Desada com a inactiva",
    "Start with one whole-hotel rule, then add category rules only where you really want different behavior. Keep only one active rule per room category.":
      "Comença amb una regla per a tot l'hotel i afegeix regles per categoria només quan realment necessitis un comportament diferent. Mantén una sola regla activa per categoria d'habitació.",
    "1. Where should this rule apply?": "1. On s'ha d'aplicar aquesta regla?",
    "Start by choosing whether this rule is for the whole hotel or for one room category only.":
      "Comença escollint si aquesta regla s'aplica a tot l'hotel o només a una categoria d'habitació.",
    "Use one single pricing posture for the whole hotel.":
      "Aplica una única estratègia de preus a tot l'hotel.",
    "Use a different posture for one specific room category.":
      "Aplica una estratègia diferent a una categoria d'habitació concreta.",
    "Use this when one room category needs a different strategy than the rest of the hotel.":
      "Utilitza aquesta opció quan una categoria d'habitació necessiti una estratègia diferent de la resta de l'hotel.",
    "2. What should the optimizer prioritize?": "2. Què ha de prioritzar l'optimitzador?",
    "Pick the commercial goal that best describes how you want this rule to behave.":
      "Tria l'objectiu comercial que descrigui millor com vols que es comporti aquesta regla.",
    "The optimizer will be more willing to move price to improve occupancy.":
      "L'optimitzador estarà més disposat a ajustar el preu per millorar l'ocupació.",
    "The optimizer will defend average daily rate even if it sells a bit slower.":
      "L'optimitzador defensarà la tarifa mitjana diària encara que el ritme de venda sigui una mica més lent.",
    "The optimizer will try to balance occupancy and average price.":
      "L'optimitzador intentarà equilibrar l'ocupació i el preu mitjà.",
    "3. Price guardrails": "3. Límits de preu",
    "These limits keep recommendations inside your commercial comfort zone. Leave a field empty if you do not want to force that rule.":
      "Aquests límits mantenen les recomanacions dins del teu marge comercial. Deixa un camp buit si no vols imposar aquest límit.",
    "Optional. Example: 78 means the RMS will try to finish around 78% occupancy.":
      "Opcional. Per exemple, 78 indica que el RMS intentarà acabar prop del 78 % d'ocupació.",
    "Optional. Use this to defend the average selling level that this strategy should achieve across its dates. It tells the RMS to keep the overall price posture healthy, even if some individual days move differently.":
      "Opcional. Utilitza-ho per defensar el nivell mitjà de venda que aquesta estratègia ha d'assolir durant les seves dates. Indica al RMS que mantingui una posició general de preu saludable, encara que alguns dies concrets variïn.",
    "This field is only available in room-category rules, so it does not push every category in the hotel to the same minimum.":
      "Aquest camp només està disponible en regles per categoria d'habitació, per evitar imposar el mateix mínim a totes les categories de l'hotel.",
    "Optional. 100 means match the market. 105 means aim about 5% above. 95 means aim about 5% below.":
      "Opcional. 100 significa igualar el mercat; 105, situar-se aproximadament un 5 % per sobre; i 95, un 5 % per sota.",
    "Optional absolute safety floor. No single recommended day should go below this amount.":
      "Llindar de seguretat absolut opcional. Cap dia recomanat no hauria de quedar per sota d'aquest import.",
    "This field is only available in room-category rules, so one hotel rule cannot set the same absolute minimum for all categories.":
      "Aquest camp només està disponible en regles per categoria d'habitació, de manera que una regla d'hotel no pugui fixar el mateix mínim absolut per a totes les categories.",
    "Optional hard ceiling. The RMS should not recommend a higher selling price than this.":
      "Sostre màxim opcional. El RMS no hauria de recomanar un preu de venda superior a aquest import.",
    "4. Minimum stay rules": "4. Regles d'estada mínima",
    "Decide whether the RMS may tighten or relax minimum stay and how far it may go.":
      "Decideix si el RMS pot endurir o relaxar l'estada mínima i fins on pot arribar.",
    Allowed: "Permès",
    Locked: "Bloquejat",
    "Turn this on if the RMS may reduce minimum stay to help fill softer dates.":
      "Activa-ho si el RMS pot reduir l'estada mínima per ajudar a omplir les dates amb menys demanda.",
    "Turn this on if the RMS may increase minimum stay on stronger dates.":
      "Activa-ho si el RMS pot augmentar l'estada mínima en dates amb més demanda.",
    "Lowest minimum stay the RMS may use. Example: 1 means one-night stays are allowed if the rule says so.":
      "Estada mínima més curta que pot utilitzar el RMS. Per exemple, 1 permet estades d'una nit quan la regla ho indiqui.",
    "Highest minimum stay the RMS may use. This must be equal to or above the shortest minimum stay.":
      "Estada mínima més llarga que pot utilitzar el RMS. Ha de ser igual o superior a l'estada mínima més curta.",
    "5. How far ahead should the RMS guide prices?":
      "5. Amb quanta antelació ha d'orientar els preus el RMS?",
    "First choose how many days get one exact recommendation per day. After that, the RMS groups future dates into longer periods and gives one guidance level for each period.":
      "Tria primer quants dies rebran una recomanació exacta per dia. Després, el RMS agruparà les dates futures en períodes més llargs i assignarà un nivell d'orientació a cada període.",
    "How many days ahead the RMS should recommend one exact price per day.":
      "Nombre de dies futurs per als quals el RMS ha de recomanar un preu exacte per dia.",
    "This is the shortest future period the RMS may group together after the daily horizon ends. Example: 7 means it can build weekly periods, but not tiny 2- or 3-day periods.":
      "És el període futur més curt que el RMS pot agrupar un cop acabat l'horitzó diari. Per exemple, 7 permet crear períodes setmanals, però no períodes de només 2 o 3 dies.",
    "Build long-range guidance around your seasonality periods when they exist.":
      "Genera l'orientació a llarg termini a partir dels períodes d'estacionalitat quan existeixin.",
    "Build long-range guidance in regular calendar ranges.":
      "Genera l'orientació a llarg termini mitjançant rangs regulars de calendari.",
    "Seasonality periods": "Períodes d'estacionalitat",
    "6. Should this strategy be used now?": "6. S'ha d'utilitzar ara aquesta estratègia?",
    "You can save a rule without activating it yet if you are still preparing your setup.":
      "Pots desar una regla sense activar-la encara si continues preparant la configuració.",
    Active: "Activa",
    Inactive: "Inactiva",
    "Active strategies are used by the RMS. Inactive ones are saved for later and do not affect recommendations.":
      "El RMS utilitza les estratègies actives. Les inactives es desen per a més endavant i no afecten les recomanacions.",
    "Configuration data": "Dades de configuració",
    "Recommended setup:": "Configuració recomanada:",
    "How decisions are made:": "Com es prenen les decisions:",
    "What a template is:": "Què és una plantilla:",
    "How it is used later:": "Com s'utilitza més endavant:",
    "Tip:": "Consell:",
    "What this section does:": "Què fa aquesta secció:",
    "How priority works:": "Com funciona la prioritat:",
    "First create a season template": "Primer crea una plantilla de temporada",
    "What a profile is:": "Què és un perfil:",
    "How it works:": "Com funciona:",
    "What this is for:": "Per a què serveix això:",
    "Good examples:": "Bons exemples:",
    "Decision order:": "Ordre de decisió:",
    "What the RMS does:": "Què fa el RMS:",
    "How the RMS uses strategy rules:": "Com fa servir el RMS les regles d'estratègia:",
    "Create one active rule for the whole hotel as your base strategy, then add extra active rules only for room categories that need different behavior.":
      "Crea una regla activa per a tot l'hotel com a estratègia base i afegeix regles actives extres només per a les categories d'habitació que necessitin un comportament diferent.",
    "Keep just one active rule per room category. The selected strategy influences the goal, price limits, minimum-stay freedom and planning horizon used by the RMS recommendation.":
      "Mantén una sola regla activa per categoria d'habitació. L'estratègia seleccionada influeix en l'objectiu, els límits de preu, la flexibilitat de l'estada mínima i l'horitzó de planificació que utilitza la recomanació del RMS.",
    "The RMS uses the room-category rule first. If there is no active category rule, it uses the whole-hotel rule instead.":
      "El RMS fa servir primer la regla de categoria d'habitació. Si no hi ha cap regla activa de categoria, fa servir la regla de tot l'hotel.",
    "One reusable season label such as low season, shoulder season or peak season.":
      "Una etiqueta de temporada reutilitzable, com ara temporada baixa, mitjana o punta.",
    "In the next sections you assign date ranges to that template and, if needed, refine behavior by room type and day of week.":
      "A les seccions següents assignes rangs de dates a aquesta plantilla i, si cal, en refines el comportament per tipus d'habitació i dia de la setmana.",
    "Keep the templates broad and simple. A child should be able to understand the season names at first glance.":
      "Mantén les plantilles àmplies i simples. Un infant hauria de poder entendre els noms de temporada d'un cop d'ull.",
    "Here you place each season template on the real calendar.":
      "Aquí col·loques cada plantilla de temporada sobre el calendari real.",
    "If two periods overlap, the higher priority wins on those dates.":
      "Si dos períodes se solapen, la prioritat més alta guanya en aquestes dates.",
    "Use one normal-priority base season for most dates and only raise priority for special overrides such as fairs, Easter or local events.":
      "Fes servir una temporada base de prioritat normal per a la majoria de dates i puja la prioritat només per a overrides especials com fires, Setmana Santa o esdeveniments locals.",
    "before adding date ranges here.": "abans d'afegir aquí rangs de dates.",
    "A refinement inside one season template.": "Un refinament dins d'una plantilla de temporada.",
    "First the RMS finds the season by date. Then it can refine that season for one of your room categories and, if needed, one day of the week.":
      "Primer el RMS identifica la temporada per data. Després pot refinar aquesta temporada per a una de les teves categories d'habitació i, si cal, per a un dia concret de la setmana.",
    "Create a profile only when one room category, or one weekday inside that room category, behaves differently from the main season.":
      "Crea un perfil només quan una categoria d'habitació, o un dia concret dins d'aquesta categoria, es comporti de manera diferent de la temporada principal.",
    "before defining profile refinements.": "abans de definir refinaments de perfil.",
    "Use disruptions for unusual situations that sit on top of normal seasonality, not instead of it.":
      "Fes servir disrupcions per a situacions poc habituals que se superposen a l'estacionalitat normal, no per substituir-la.",
    "Each active disruption adds a temporary factor that makes the RMS firmer or softer during the chosen date range.":
      "Cada disrupció activa afegeix un factor temporal que fa que el RMS sigui més ferm o més flexible durant el rang de dates escollit.",
    "A big concert week, a transport strike, major road works nearby or a sudden weather shock.":
      "Una setmana de grans concerts, una vaga de transport, obres importants a prop o un xoc meteorològic sobtat.",
    "The RMS first identifies the season from `Seasonality Periods`, then looks here for a more specific refinement.":
      "El RMS identifica primer la temporada a `Seasonality Periods` i després busca aquí un refinament més específic.",
    "It turns each active disruption into a temporary price factor around 1.0 during the selected dates.":
      "Converteix cada disrupció activa en un factor temporal de preu al voltant d'1.0 durant les dates seleccionades.",
    "It first looks for one active rule for the room category. If it does not find one, it falls back to the active whole-hotel rule.":
      "Primer busca una regla activa per a la categoria d'habitació. Si no la troba, recorre a la regla activa de tot l'hotel.",
    "Pricing products": "Productes tarifaris",
    Products: "Productes",
    "Choose the independent master room rate the RMS should optimize for every room category.":
      "Tria la tarifa mestra independent que l'RMS ha d'optimitzar per a cada categoria d'habitació.",
    "Choose the independent master rate and verify every active product derives from it.":
      "Tria la tarifa mestra independent i verifica que cada producte actiu en derivi.",
    "Complete when every room category has one active and valid master room rate policy.":
      "Es completa quan cada categoria d'habitació té una política de tarifa mestra activa i vàlida.",
    "Complete when every category has a valid master, product guardrails and executable derived-rate rules for the operating horizon.":
      "Es completa quan cada categoria té una mestra vàlida, límits per producte i regles derivades executables per a l'horitzó operatiu.",
    "Master room rates": "Tarifes mestres",
    "The independent room rate optimized by the RMS for each room category.":
      "La tarifa independent que optimitza l'RMS per a cada categoria d'habitació.",
    "Master rates configured": "Tarifes mestres configurades",
    "Product policies ready": "Polítiques de producte preparades",
    "{count} still without a ready product policy":
      "{count} encara sense una política de producte preparada",
    "Master and derived products ready for every room category":
      "Productes mestres i derivats preparats per a cada categoria d'habitació",
    "{configured}/{total} product policies ready":
      "{configured}/{total} polítiques de producte preparades",
    "{count} still without a valid master rate":
      "{count} encara sense una tarifa mestra vàlida",
    "Master rate ready for every room category":
      "Tarifa mestra preparada per a cada categoria d'habitació",
    "{configured}/{total} master rates configured":
      "{configured}/{total} tarifes mestres configurades",
    "Choose a master room rate for {category}.":
      "Tria una tarifa mestra per a {category}.",
    "this room category": "aquesta categoria d'habitació",
    "The selected master rate is not valid for this room category.":
      "La tarifa mestra seleccionada no és vàlida per a aquesta categoria d'habitació.",
    "Could not save the master room rate policy.":
      "No s'ha pogut desar la política de tarifa mestra.",
    "Choose the one independent rate the RMS may optimize in each room category.":
      "Tria l'única tarifa independent que l'RMS pot optimitzar en cada categoria d'habitació.",
    "{configured}/{total} configured": "{configured}/{total} configurades",
    "What the RMS changes:": "Què canvia l'RMS:",
    "Recommendations target only the selected master rate. Derived non-refundable, meal, occupancy and channel products keep following their existing PMS rules.":
      "Les recomanacions actuen només sobre la tarifa mestra seleccionada. Els productes derivats no reemborsables, per règim, ocupació i canal continuen seguint les seves regles actuals del PMS.",
    "Safe selection:": "Selecció segura:",
    "Only active independent rates from the same room category are available here.":
      "Aquí només hi ha disponibles tarifes independents actives de la mateixa categoria d'habitació.",
    "Loading master room rates...": "Carregant tarifes mestres...",
    "Master room rate": "Tarifa mestra",
    "Rate guardrails": "Límits de tarifa",
    "Derived products": "Productes derivats",
    "{traced}/{total} linked to master": "{traced}/{total} vinculats a la mestra",
    "Derivation check unavailable": "Comprovació de derivació no disponible",
    "Coverage: {from} to {to}": "Cobertura: {from} a {to}",
    "+{count} more issues": "+{count} incidències més",
    "Master rate policy is missing": "Falta la política de tarifa mestra",
    "More than one active master policy was found":
      "S'ha trobat més d'una política mestra activa",
    "The selected master rate is not valid": "La tarifa mestra seleccionada no és vàlida",
    "The master rate does not cover the operating horizon":
      "La tarifa mestra no cobreix l'horitzó operatiu",
    "This active rate is independent from the master":
      "Aquesta tarifa activa és independent de la mestra",
    "The derived-rate chain contains a cycle":
      "La cadena de tarifes derivades conté un cicle",
    "The derived-rate chain crosses room categories":
      "La cadena de tarifes derivades creua categories d'habitació",
    "A parent rate is missing": "Falta una tarifa pare",
    "A required parent rate is inactive": "Una tarifa pare necessària està inactiva",
    "A synchronized master-group rate is missing":
      "Falta una tarifa sincronitzada del grup de la tarifa mestra",
    "A synchronized master-group rate is derived and cannot be used as a price seed":
      "Una tarifa sincronitzada del grup de la tarifa mestra és derivada i no es pot usar com a origen de preu",
    "A downstream derived rate is missing":
      "Falta una tarifa derivada posterior a la cadena",
    "A synchronized master-group rate is inactive":
      "Una tarifa sincronitzada del grup de la tarifa mestra està inactiva",
    "A downstream derived rate is inactive":
      "Una tarifa derivada posterior a la cadena està inactiva",
    "A synchronized rate in this product group is inactive":
      "Una tarifa sincronitzada d'aquest grup de productes està inactiva",
    "The rate has more than one derivation relationship":
      "La tarifa té més d'una relació de derivació",
    "The formula has no input rates": "La fórmula no té tarifes d'entrada",
    "The linked formula is missing": "Falta la fórmula vinculada",
    "This product needs its own floor and ceiling":
      "Aquest producte necessita els seus propis preus mínim i màxim",
    "This product has invalid floor or ceiling values":
      "Aquest producte té valors mínim o màxim no vàlids",
    "This product has no whole price between its floor and ceiling":
      "Aquest producte no té cap preu enter entre el seu mínim i el seu màxim",
    "This product has inconsistent default min/max stay restrictions for at least one weekday":
      "Aquest producte té restriccions predeterminades d'estada mínima/màxima incoherents en almenys un dia de la setmana",
    "The simple derived-rate adjustment is invalid":
      "L'ajust de la tarifa derivada simple no és vàlid",
    "The derived-rate formula is invalid": "La fórmula de tarifa derivada no és vàlida",
    "Custom derived formulas are not supported by RMS yet":
      "L'RMS encara no admet fórmules derivades personalitzades",
    "This derived product does not cover the operating horizon":
      "Aquest producte derivat no cobreix l'horitzó operatiu",
    "A synchronized rate in this product group does not cover the operating horizon":
      "Una tarifa sincronitzada d'aquest grup de productes no cobreix l'horitzó operatiu",
    "This product has an invalid currency code; use a three-letter ISO code":
      "Aquest producte té un codi de moneda no vàlid; fes servir un codi ISO de tres lletres",
    "This product uses a different currency from the master":
      "Aquest producte fa servir una moneda diferent de la tarifa mestra",
    "Synchronized rates in this product group use different currencies":
      "Les tarifes sincronitzades d'aquest grup de productes fan servir monedes diferents",
    "Synchronized rates in this product group have incompatible price limits":
      "Les tarifes sincronitzades d'aquest grup de productes tenen límits de preu incompatibles",
    "The derived-rate relationship is invalid":
      "La relació de tarifa derivada no és vàlida",
    Policy: "Política",
    "Master room rate for {category}": "Tarifa mestra per a {category}",
    "Choose a master room rate": "Tria una tarifa mestra",
    "No independent active rates available":
      "No hi ha tarifes independents actives disponibles",
    "Current selection is no longer available":
      "La selecció actual ja no està disponible",
    "Create or activate an independent room rate with floor and ceiling for this category first.":
      "Primer crea o activa una tarifa independent amb preu mínim i màxim per a aquesta categoria.",
    "Version {version}": "Versió {version}",
    Product: "Producte",
    "Policy v{version}": "Política v{version}",
    Saved: "Desada",
    "Save change": "Desar canvi",
    "Save master rate": "Desar tarifa mestra",
  },
};

export function getRmsLocale(languageId, language) {
  if (languageId === "en") return undefined;
  if (language?.locale) return language.locale;
  if (languageId === "ca") return "ca-ES";
  return "es-ES";
}

export function createRmsTranslator(languageId) {
  const dictionary = RMS_TRANSLATIONS[languageId] || {};
  return (key, replacements = {}) => {
    const template = dictionary[key] || key;
    return template.replace(/\{(\w+)\}/g, (_match, token) =>
      Object.prototype.hasOwnProperty.call(replacements, token)
        ? String(replacements[token])
        : `{${token}}`
    );
  };
}

export function translateRmsStatus(languageId, status) {
  const normalized = String(status || "").toLowerCase();
  return createRmsTranslator(languageId)(normalized);
}

export function formatRmsCount(value, locale = undefined) {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return "-";
  return numeric.toLocaleString(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}
